// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../.yarn/__virtual__/css-loader-virtual-db5a836fc3/2/root/.yarn/berry/cache/css-loader-npm-7.1.2-7540f12884-10c0.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../.yarn/__virtual__/css-loader-virtual-db5a836fc3/2/root/.yarn/berry/cache/css-loader-npm-7.1.2-7540f12884-10c0.zip/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../.yarn/__virtual__/css-loader-virtual-db5a836fc3/2/root/.yarn/berry/cache/css-loader-npm-7.1.2-7540f12884-10c0.zip/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/fonts/Candara.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/fonts/OpenSans-VariableFont_wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/new-point.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/auth-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Candara";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
}
@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 700;
  font-style: normal;
}
.nautilus-font, .button-text, .button, .button-regular-gray, .button-regular, .button-window-action, .app .poi .save > .buttons > button.button-close, .app .profile .profile-panel > .header > button, .app .track .save > .buttons > button.button-close, .app .tongue > .tongue-wrapper > .header > .actions > button, .button-primary, .list-text, .app .poi .view .tongue-wrapper > .point > .point-data .text, .app .popup > div.popup-content .feature-popup-form .row, .small-text, .app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .hint, .app .menu .pages > .items > div > span, .app .popup > div.popup-content .feature-popup-form, .regular-text, .desktop-styles.modal .ant-modal-content .ant-modal-body, .modal.ant-notification-desktop .ant-modal-content .ant-modal-body, .modal.modal-desktop .ant-modal-content .ant-modal-body, .modal.device-type-desktop .ant-modal-content .ant-modal-body, .tablet-styles.modal .ant-modal-content .ant-modal-body, .modal.ant-notification-tablet .ant-modal-content .ant-modal-body, .modal.modal-tablet .ant-modal-content .ant-modal-body, .modal.device-type-tablet .ant-modal-content .ant-modal-body, .app .poi .view .tongue-wrapper > .buttons > button.button-error, .app .poi .view .tongue-wrapper > .buttons > button.button-publish, .app .profile .main > .tongue-wrapper > .row.boat-info > .description > .text, .ant-notification .error-notification .ant-notification-notice-message, .primary-text, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category > .title, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-empty-text > span, .app .profile .profile-panel.boat-info-form > .ant-form > .header > .text, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input::placeholder, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-placeholder, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-item, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row > .ant-form-item-label > label, .app .track .list > .tongue-wrapper > .ant-list .ant-list-empty-text > span, .auth .form > div > .data .input::placeholder, .auth .form > div > .data .input input, .auth .form > div > .data .input, .modal.profile-error-modal .ant-modal-body > .text, .modal.profile-hint-modal .hint > .hint-text > div, .large-primary-text, .modal.profile-confirm-modal-modal .ant-modal-body, .modal .ant-modal-content .ant-modal-body, .list-header-text, .app .poi .view .tongue-wrapper > .point > .point-data .title, .app .profile .profile-panel.boat-info-form > .ant-form > .header > .title, .app .profile .main > .tongue-wrapper > .row > .description .title, .app .popup > div.popup-content .feature-popup-form .row.header, .secondary-header-text, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header .category > span, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row > .radius, .app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row .switch > div, .app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-icon, .app .profile .profile-panel > :not(.header) button.ant-btn-primary > span, .app .profile .profile-panel > :not(.header) button, .regular-header-text, .app .profile .main > .tongue-wrapper > .row-header, .modal.profile-error-modal .ant-modal-body > .title, .modal.profile-success-modal .ant-modal-body > .title, .modal.profile-confirm-modal-modal .ant-modal-title, .modal .ant-modal-content .ant-modal-header .ant-modal-title, .primary-header-text, .desktop-styles.modal .ant-modal-content .ant-modal-title, .modal.ant-notification-desktop .ant-modal-content .ant-modal-title, .modal.modal-desktop .ant-modal-content .ant-modal-title, .modal.device-type-desktop .ant-modal-content .ant-modal-title, .tablet-styles.modal .ant-modal-content .ant-modal-title, .modal.ant-notification-tablet .ant-modal-content .ant-modal-title, .modal.modal-tablet .ant-modal-content .ant-modal-title, .modal.device-type-tablet .ant-modal-content .ant-modal-title, .app .profile .profile-panel > .header, .app .tongue > .tongue-wrapper > .header, .large-header-text {
  font-family: Open Sans;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.large-header-text {
  color: #17253C;
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
}

.primary-header-text, .desktop-styles.modal .ant-modal-content .ant-modal-title, .modal.ant-notification-desktop .ant-modal-content .ant-modal-title, .modal.modal-desktop .ant-modal-content .ant-modal-title, .modal.device-type-desktop .ant-modal-content .ant-modal-title, .tablet-styles.modal .ant-modal-content .ant-modal-title, .modal.ant-notification-tablet .ant-modal-content .ant-modal-title, .modal.modal-tablet .ant-modal-content .ant-modal-title, .modal.device-type-tablet .ant-modal-content .ant-modal-title, .app .profile .profile-panel > .header, .app .tongue > .tongue-wrapper > .header {
  color: #17253C;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}

.regular-header-text, .app .profile .main > .tongue-wrapper > .row-header, .modal.profile-error-modal .ant-modal-body > .title, .modal.profile-success-modal .ant-modal-body > .title, .modal.profile-confirm-modal-modal .ant-modal-title, .modal .ant-modal-content .ant-modal-header .ant-modal-title {
  color: #17253C;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
}

.secondary-header-text, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header .category > span, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row > .radius, .app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row .switch > div, .app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-icon, .app .profile .profile-panel > :not(.header) button.ant-btn-primary > span, .app .profile .profile-panel > :not(.header) button {
  color: #17253C;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}

.list-header-text, .app .poi .view .tongue-wrapper > .point > .point-data .title, .app .profile .profile-panel.boat-info-form > .ant-form > .header > .title, .app .profile .main > .tongue-wrapper > .row > .description .title, .app .popup > div.popup-content .feature-popup-form .row.header {
  color: #17253C;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
}

.large-primary-text, .modal.profile-confirm-modal-modal .ant-modal-body, .modal .ant-modal-content .ant-modal-body {
  color: #7E8591;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.primary-text, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category > .title, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-empty-text > span, .app .profile .profile-panel.boat-info-form > .ant-form > .header > .text, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input::placeholder, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-placeholder, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-item, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row > .ant-form-item-label > label, .app .track .list > .tongue-wrapper > .ant-list .ant-list-empty-text > span, .auth .form > div > .data .input::placeholder, .auth .form > div > .data .input input, .auth .form > div > .data .input, .modal.profile-error-modal .ant-modal-body > .text, .modal.profile-hint-modal .hint > .hint-text > div {
  color: #7E8591;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.regular-text, .desktop-styles.modal .ant-modal-content .ant-modal-body, .modal.ant-notification-desktop .ant-modal-content .ant-modal-body, .modal.modal-desktop .ant-modal-content .ant-modal-body, .modal.device-type-desktop .ant-modal-content .ant-modal-body, .tablet-styles.modal .ant-modal-content .ant-modal-body, .modal.ant-notification-tablet .ant-modal-content .ant-modal-body, .modal.modal-tablet .ant-modal-content .ant-modal-body, .modal.device-type-tablet .ant-modal-content .ant-modal-body, .app .poi .view .tongue-wrapper > .buttons > button.button-error, .app .poi .view .tongue-wrapper > .buttons > button.button-publish, .app .profile .main > .tongue-wrapper > .row.boat-info > .description > .text, .ant-notification .error-notification .ant-notification-notice-message {
  color: #7E8591;
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
}

.small-text, .app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .hint, .app .menu .pages > .items > div > span, .app .popup > div.popup-content .feature-popup-form {
  color: #7E8591;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
}

.list-text, .app .poi .view .tongue-wrapper > .point > .point-data .text, .app .popup > div.popup-content .feature-popup-form .row {
  color: #7E8591;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}

.dark-text, .app .popup > div.popup-content .feature-popup-form .row > div:first-child {
  color: #17253C;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
html {
  height: 100%;
  font-family: Open Sans;
  color: #17253C;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
html body {
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
html body > div#root {
  height: 100%;
}
html body > div#root > div {
  height: 100%;
}

.loader {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
}
.loader > div:nth-child(2) path {
  fill-opacity: 0;
}

.button-text, .button, .button-regular-gray, .button-regular, .button-window-action, .app .poi .save > .buttons > button.button-close, .app .profile .profile-panel > .header > button, .app .track .save > .buttons > button.button-close, .app .tongue > .tongue-wrapper > .header > .actions > button, .button-primary {
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.button, .button-regular-gray, .button-regular, .button-window-action, .app .poi .save > .buttons > button.button-close, .app .profile .profile-panel > .header > button, .app .track .save > .buttons > button.button-close, .app .tongue > .tongue-wrapper > .header > .actions > button, .button-primary {
  height: 48px;
  border-radius: 12px;
  padding: 14px 16px;
}
.button:has(.loader), .button-regular-gray:has(.loader), .button-regular:has(.loader), .button-window-action:has(.loader), .app .poi .save > .buttons > button.button-close:has(.loader), .app .profile .profile-panel > .header > button:has(.loader), .app .track .save > .buttons > button.button-close:has(.loader), .app .tongue > .tongue-wrapper > .header > .actions > button:has(.loader), .button-primary:has(.loader) {
  padding: 0;
}

.button-primary {
  background-color: #0960A3;
  color: #FFFFFF;
}

.button-regular, .button-window-action, .app .poi .save > .buttons > button.button-close, .app .profile .profile-panel > .header > button, .app .track .save > .buttons > button.button-close, .app .tongue > .tongue-wrapper > .header > .actions > button {
  background-color: #FFFFFF !important;
  color: #374151 !important;
}

.button-window-action, .app .poi .save > .buttons > button.button-close, .app .profile .profile-panel > .header > button, .app .track .save > .buttons > button.button-close, .app .tongue > .tongue-wrapper > .header > .actions > button {
  height: 24px !important;
  width: 24px !important;
  min-width: 24px !important;
  border: 0;
  box-shadow: unset;
}
.button-window-action > span, .app .poi .save > .buttons > button.button-close > span, .app .profile .profile-panel > .header > button > span, .app .track .save > .buttons > button.button-close > span, .app .tongue > .tongue-wrapper > .header > .actions > button > span {
  color: #A1A9B5 !important;
}

.button-regular-gray {
  background-color: rgba(145, 158, 171, 0.1215686275) !important;
  color: #374151;
}

.float-buttons button {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.float-buttons button div {
  width: 48px !important;
  height: 48px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
}
.float-buttons button div.ant-float-btn-body {
  border-radius: 8px;
}
.float-buttons .zoom {
  position: absolute;
  z-index: 10;
  bottom: calc(50% - 32px);
  right: 20px;
}
.float-buttons .zoom > button:first-child > div {
  position: relative;
  top: -1px;
}
.float-buttons .aim {
  position: absolute;
  z-index: 10;
  bottom: calc(50% - 88px);
  right: 12px;
}
.float-buttons .compas, .float-buttons .to-north {
  position: absolute;
  z-index: 10;
  bottom: calc(50% - 144px);
  right: 12px;
}
.float-buttons .to-north svg {
  transform: rotate(-90deg);
}
.float-buttons .poi {
  position: absolute;
  z-index: 10;
  bottom: calc(50% - 202px);
  right: 12px;
}
.float-buttons .osm {
  position: absolute;
  z-index: 10;
  bottom: calc(50% - 260px);
  right: 12px;
}

.modal {
  width: min(460px, 100% - 32px);
  margin: 16px auto !important;
}
.modal .ant-modal-content .ant-modal-close {
  background-color: rgba(145, 158, 171, 0.1215686275);
  width: 24px;
  height: 24px;
  border-radius: 16px;
}
.modal .ant-modal-content .ant-modal-close svg {
  width: 12px;
  height: 12px;
}
.modal .ant-modal-content .ant-modal-header .ant-modal-title .centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.modal .ant-modal-content .ant-modal-header .ant-modal-title .centered > img {
  margin-top: 10px;
  margin-bottom: 20px;
}
.modal .ant-modal-content .ant-modal-body {
  color: #374151;
}
.modal .ant-modal-content .ant-modal-footer {
  margin-top: 20px;
}
.modal .ant-modal-content .ant-modal-footer > .buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.modal .ant-modal-content .ant-modal-footer > .buttons > button {
  margin: 8px 0;
}
.modal .ant-modal-content .ant-modal-footer > .buttons > button:only-child {
  width: 100%;
}
.modal.profile-confirm-modal-modal .ant-modal-title {
  color: #17253C;
  margin: 8px 26px 8px 0;
}
.modal.profile-confirm-modal-modal .ant-modal-body {
  color: #374151;
  margin: 10px 0;
}
.modal.profile-success-modal .ant-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal.profile-success-modal .ant-modal-body > img {
  margin: 10px 0;
}
.modal.profile-success-modal .ant-modal-body > .title {
  color: #17253C;
  text-align: center;
  margin: 10px 0;
}
.modal.profile-hint-modal .hint > .hint-text > div {
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: #374151;
}
.modal.profile-error-modal .ant-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal.profile-error-modal .ant-modal-body > .error-icon {
  width: 100px;
  height: 100px;
  background-color: red;
  margin-bottom: 20px;
}
.modal.profile-error-modal .ant-modal-body > .title {
  color: #17253C;
  text-align: center;
}
.modal.profile-error-modal .ant-modal-body > .text {
  color: #374151;
  margin: 10px 0;
  text-align: center;
}

.ant-notification .error-notification {
  background-color: #FFDCDC;
  padding: 8px 12px 8px 16px !important;
}
.ant-notification .error-notification .ant-notification-notice-message {
  color: #F13B3B !important;
  margin: 0;
  text-align: center;
}
.ant-notification .error-notification .ant-notification-notice-close {
  inset-inline-end: 8px;
  top: calc(50% - 11px);
}
.ant-notification .error-notification .ant-notification-notice-close svg {
  color: #F13B3B;
  width: 10px;
  height: 10px;
}

.auth {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  backdrop-filter: blur(16.1000003815px);
}
.auth .form {
  display: flex;
  flex-direction: column;
  width: 350px;
  max-width: 92%;
  height: 100%;
  padding-top: 12px;
}
.auth .form > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.auth .form > div.logo {
  align-self: center;
}
.auth .form > div.footer {
  padding: 24px 0;
}
.auth .form > div.footer > span {
  text-align: center;
}
.auth .form > div.footer > span > a {
  color: #0960A3;
  padding-left: 0.3em;
  cursor: pointer;
}
.auth .form > div > .welcome-text {
  padding: 20px 7px 32px 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.auth .form > div > .welcome-text > div {
  text-align: center;
}
.auth .form > div > .welcome-text > div:first-child {
  padding-bottom: 12px;
}
.auth .form > div > .data {
  flex-grow: 1;
}
.auth .form > div > .data .input {
  color: #17253C;
  padding: 14px 16px;
  border: 1px solid #DCDFE6;
  border-radius: 8px;
  width: 100%;
  margin-bottom: 16px;
}
.auth .form > div > .data .input input {
  padding: 0;
  color: #17253C;
}
.auth .form > div > .data .input::placeholder {
  color: #A1A9B5;
}
.auth .form > div > .data .input.ant-input-status-error {
  border-color: #F13B3B !important;
}
.auth .form > div > button {
  width: 100%;
}
.auth .form > div.login {
  flex-grow: 1;
}
.auth .form > div.login > .data > .smart-captcha {
  width: 100%;
  padding-bottom: 16px;
}

.app {
  --map-height: 100vh;
  --map-width: 100%;
  --map-offset-x: 0;
  --map-offset-y: 0;
}
.app .map-element {
  height: var(--map-height);
  width: var(--map-width);
  cursor: default;
}
.app .map-element > .ol-viewport {
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
.app .popup {
  --height: 0px;
  --width: 0px;
  --icon-height: 0px;
  --icon-width: 0px;
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 0;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: calc(0px - var(--height) / 2);
  left: 27px;
  max-width: 300px;
}
.app .popup:after, .app .popup:before {
  bottom: calc(var(--height) / 2);
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  transform: rotate(90deg);
}
.app .popup:after {
  border-top-color: white;
  border-width: 10px;
  left: -10px;
  margin-left: -9px;
}
.app .popup:before {
  bottom: calc(var(--height) / 2 - 1px);
  border-top-color: #cccccc;
  border-width: 11px;
  left: -11px;
  margin-left: -11px;
}
.app .popup.position-left {
  left: unset;
  right: 27px;
}
.app .popup.position-left:before, .app .popup.position-left:after {
  left: unset;
  transform: rotate(-90deg);
}
.app .popup.position-left:before {
  right: -23px;
}
.app .popup.position-left:after {
  right: -20px;
}
.app .popup.position-down {
  bottom: unset;
  top: 15px;
  left: calc(var(--width) / 2 * -1);
}
.app .popup.position-down:before, .app .popup.position-down:after {
  top: -23px;
  bottom: unset;
  transform: rotate(180deg);
}
.app .popup.position-down:before {
  left: calc(var(--width) / 2 + 1px);
}
.app .popup.position-down:after {
  top: -20px;
  left: calc(var(--width) / 2);
}
.app .popup.position-up {
  bottom: calc(var(--icon-height) + 15px);
  left: calc(var(--width) / 2 * -1);
}
.app .popup.position-up:before, .app .popup.position-up:after {
  bottom: -20px;
  transform: rotate(0deg);
}
.app .popup.position-up:before {
  bottom: -23px;
  left: calc(var(--width) / 2 + 1px);
}
.app .popup.position-up:after {
  left: calc(var(--width) / 2);
}
.app .popup > button {
  text-decoration: none;
  position: absolute;
  top: 12px;
  right: 16px;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  background-color: rgba(145, 158, 171, 0.1215686275);
  border: none;
}
.app .popup > button svg {
  font-size: 14px;
  fill: #A1A9B5;
}
.app .popup > div.popup-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
}
.app .popup > div.popup-content .feature-popup-form {
  display: flex;
  flex-direction: column;
}
.app .popup > div.popup-content .feature-popup-form .row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-bottom: 1px solid #E9E9EB;
}
.app .popup > div.popup-content .feature-popup-form .row.header {
  border-bottom: none;
  padding: 5px 0;
}
.app .popup > div.popup-content .feature-popup-form .row > div:first-child {
  padding-right: 10px;
  width: 100px;
  flex-shrink: 0;
}
.app .popup > div.popup-content .feature-popup-form .row > div:first-child:after {
  content: ":";
}
.app .popup > div.popup-content .feature-popup-form .row > div:nth-child(2) {
  min-width: 150px;
  flex-grow: 1;
}
.app .popup > div.popup-content .feature-popup-form .row > div:nth-child(2).obj_name {
  font-weight: 600;
  color: #124A74;
}
.app .menu {
  z-index: 10;
  position: absolute;
  min-width: 330px;
  width: min(100% - 44px, 350px);
  height: 86px;
  left: 50%;
  transform: translateX(-50%);
  bottom: -120px;
  background-color: rgba(100, 100, 100, 0.3098039216);
  border-radius: 20px;
  transition: 0.5s;
}
.app .menu.with-pagination {
  height: 106px;
}
.app .menu.show {
  bottom: 20px !important;
}
.app .menu .pages {
  display: flex;
  overflow: auto;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
}
.app .menu .pages::-webkit-scrollbar {
  display: none;
}
.app .menu .pages > .items {
  scroll-snap-align: start;
  min-width: 100%;
  height: 72px;
  padding-top: 8px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  overflow-x: auto;
  gap: 44px;
  justify-content: center;
}
.app .menu .pages > .items > div {
  height: 100%;
  width: 40px;
  min-width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.app .menu .pages > .items > div > div.item {
  background-color: #F0F2F5;
  border: 1px solid #FFFFFF;
  border-radius: 15px;
  width: 40px;
  min-width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.app .menu .pages > .items > div > div.item.disabled {
  background-color: rgba(240, 242, 245, 0.4);
  border-width: 0;
}
.app .menu .pages > .items > div > div.item svg {
  --fill: none;
}
.app .menu .pages > .items > div > div.item svg.friend-icon {
  position: relative;
  bottom: -9px;
}
.app .menu .pages > .items > div > div.item svg.adapter-icon {
  position: relative;
  bottom: -4px;
  right: -4px;
}
.app .menu .pages > .items > div > div.item > .anticon {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app .menu .pages > .items > div > div.item > .anticon > svg {
  width: 80%;
  height: 80%;
}
.app .menu .pages > .items > div > div.selected {
  position: absolute;
  height: 5px;
  width: 40px;
  top: 0;
  background-color: #26343F;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.app .menu .pages > .items > div > span {
  color: #FFFFFF !important;
}
.app .menu > .pagination {
  padding: 8px 0 12px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
}
.app .menu > .pagination > .page-circle {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: #C6CCD6;
}
.app .menu > .pagination > .page-circle.selected {
  background-color: #FFFFFF;
}
.app .tongue {
  z-index: 20;
  position: absolute;
  width: 100%;
  max-height: 0;
  bottom: 0 !important;
  left: 0;
  background-color: #FFFFFF;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  transition: max-height 0.8s;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.app .tongue.full {
  height: calc(100% - 12px);
}
.app .tongue.half {
  height: 100%;
}
.app .tongue.fit-content {
  max-height: 0;
}
.app .tongue.show.full {
  max-height: calc(100% - 12px);
}
.app .tongue.show.half {
  max-height: calc(60% - 12px);
}
.app .tongue.show.fit-content {
  max-height: 500px;
}
.app .tongue > .swipe-toggle {
  width: 100%;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app .tongue > .swipe-toggle > div {
  width: 30px;
  min-width: 30px;
  min-height: 4px;
  background-color: #C7C9CC;
}
.app .tongue > .tongue-wrapper {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.app .tongue > .tongue-wrapper > .header {
  text-align: left;
  padding: 0 16px;
}
.app .tongue > .tongue-wrapper > .header button.button-back {
  border: 0;
  box-shadow: unset;
  width: unset;
}
.app .tongue > .tongue-wrapper > .header > .actions {
  float: right;
  padding-left: 10px;
}
.app .absolute-loader, .app .poi .view .tongue-wrapper, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list, .app .track .view .tongue-wrapper, .app .track .list > .tongue-wrapper {
  position: relative;
}
.app .absolute-loader > .loader, .app .poi .view .tongue-wrapper > .loader, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .loader, .app .track .view .tongue-wrapper > .loader, .app .track .list > .tongue-wrapper > .loader {
  position: absolute;
}
.app .absolute-loader > .loader > .back, .app .poi .view .tongue-wrapper > .loader > .back, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .loader > .back, .app .track .view .tongue-wrapper > .loader > .back, .app .track .list > .tongue-wrapper > .loader > .back {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  z-index: 1;
  opacity: 0.8;
  position: absolute;
}
.app .absolute-loader > .loader > div:nth-child(2), .app .poi .view .tongue-wrapper > .loader > div:nth-child(2), .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .loader > div:nth-child(2), .app .track .view .tongue-wrapper > .loader > div:nth-child(2), .app .track .list > .tongue-wrapper > .loader > div:nth-child(2) {
  z-index: 2;
  width: 100%;
  height: 100%;
}
.app .empty-search-result {
  display: flex;
  flex-direction: column;
}
.app .adapter .header .use-adapter-switch {
  margin-left: 40px;
}
.app .adapter .body {
  padding: 16px 12px;
  text-align: right;
  height: 100%;
}
.app .adapter .body > div:first-child {
  padding-bottom: 10px;
}
.app .adapter .body > .ant-table-wrapper {
  height: calc(100% - 50px);
  overflow: auto;
}
.app .adapter .body > .ant-table-wrapper .ant-table-row.overdue {
  background-color: #DCDFE6;
}
.app .track .list > .tongue-wrapper {
  min-height: 300px;
}
.app .track .list > .tongue-wrapper > .header .add-button {
  margin-left: 16px;
  height: 32px;
  background-color: rgba(145, 158, 171, 0.1215686275) !important;
  border: none;
}
.app .track .list > .tongue-wrapper > .ant-list {
  height: 100%;
  overflow: auto;
  margin: 12px 0;
  flex-grow: 1;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item {
  padding: 16px;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item:hover {
  cursor: pointer;
  background-color: #F4F4F5;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .ant-list-item-meta-avatar {
  margin-right: 8px;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color {
  display: block;
  width: 2px;
  height: 24px;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color.color-0 {
  background-color: #124A74;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color.color-1 {
  background-color: #000000;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color.color-2 {
  background-color: #31CF13;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color.color-3 {
  background-color: #8926B3;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color.color-4 {
  background-color: #FF9812;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color.color-5 {
  background-color: #E01A4F;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .track-list-color.color-6 {
  background-color: #001AFF;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-item .ant-list-item-action > li {
  width: 32px;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-empty-text {
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.app .track .list > .tongue-wrapper > .ant-list .ant-list-empty-text > span {
  padding-top: 12px;
}
.app .track .list > .tongue-wrapper > .add-button {
  margin: 12px 16px;
}
.app .track .list > .tongue-wrapper > .filter {
  padding: 16px;
  display: flex;
  gap: 24px;
}
.app .track .list > .tongue-wrapper > .filter .ant-input-affix-wrapper {
  border-radius: 6px;
}
.app .track .list > .tongue-wrapper > .filter .ant-input-group-addon {
  display: none;
}
.app .track .list > .tongue-wrapper > .filter > button {
  padding-inline: inherit;
}
.app .track .list > .tongue-wrapper > .hide-all-button-container {
  padding: 12px 16px;
}
.app .track .list > .tongue-wrapper > .hide-all-button-container > button {
  width: 100%;
}
.app .track .list > .tongue-wrapper > .no-tracks-text {
  padding: 20px 16px;
}
.app .track .list > .tongue-wrapper > .search-error {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.app .track .list > .tongue-wrapper > .search-error > .error-text {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.app .track .list > .tongue-wrapper > .search-error > .reload-button-container {
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.app .track .list > .tongue-wrapper > .search-error > .reload-button-container > button {
  width: calc(100% - 32px);
}
.app .track .view .tongue-wrapper > .route {
  display: flex;
  padding: 24px 16px;
}
.app .track .view .tongue-wrapper > .route > .color-container {
  width: 10px;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color {
  display: block;
  width: 2px;
  height: 24px;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color.color-0 {
  background-color: #124A74;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color.color-1 {
  background-color: #000000;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color.color-2 {
  background-color: #31CF13;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color.color-3 {
  background-color: #8926B3;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color.color-4 {
  background-color: #FF9812;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color.color-5 {
  background-color: #E01A4F;
}
.app .track .view .tongue-wrapper > .route > .color-container > .track-list-color.color-6 {
  background-color: #001AFF;
}
.app .track .view .tongue-wrapper > .route > .route-data {
  flex-grow: 1;
}
.app .track .view .tongue-wrapper > .route > .route-data .list-header-text, .app .track .poi .view .tongue-wrapper > .route > .route-data .tongue-wrapper > .point > .point-data .title, .app .poi .track .view .tongue-wrapper > .route > .route-data .tongue-wrapper > .point > .point-data .title, .app .track .poi .view .tongue-wrapper > .point > .point-data .tongue-wrapper > .route > .route-data .title, .app .poi .track .view .tongue-wrapper > .point > .point-data .tongue-wrapper > .route > .route-data .title, .app .track .view .tongue-wrapper > .route > .route-data .profile .profile-panel.boat-info-form > .ant-form > .header > .title, .app .profile .track .view .tongue-wrapper > .route > .route-data .profile-panel.boat-info-form > .ant-form > .header > .title, .app .track .view .tongue-wrapper > .route > .route-data .profile .main > .tongue-wrapper > .row > .description .title, .app .profile .main > .tongue-wrapper > .row > .description .track .view .tongue-wrapper > .route > .route-data .title, .app .track .view .tongue-wrapper > .route > .route-data .popup > div.popup-content .feature-popup-form .row.header, .app .popup > div.popup-content .feature-popup-form .track .view .tongue-wrapper > .route > .route-data .row.header {
  margin-bottom: 4px;
}
.app .track .view .tongue-wrapper > .buttons {
  padding: 0 16px 16px 16px;
}
.app .track .view .tongue-wrapper > .buttons > button {
  margin: 14px;
  border: 0;
  padding: 0;
}
.app .track .dialog, .app .track .poi .new, .app .poi .track .new, .app .track .record, .app .track .start {
  width: calc(100% - 24px);
  position: absolute;
  bottom: 0;
  margin: 12px;
  background-color: #FFFFFF;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
}
.app .track .start button {
  margin: 8px 8px 6px 8px;
}
.app .track .start button.cancel {
  background-color: #FFFFFF;
  border: none;
  margin: 6px 8px 8px 8px;
}
.app .track .record .title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}
.app .track .record .title .animate {
  background-color: #ffffff;
  color: #ffffff;
  animation: fadein 1s ease-in alternate infinite;
}
.app .track .record .title .primary-text, .app .track .record .title .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category > .title, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .track .record .title .categories > .category > .title, .app .track .record .title .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-empty-text > span, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .track .record .title .ant-list-empty-text > span, .app .track .record .title .profile .profile-panel.boat-info-form > .ant-form > .header > .text, .app .profile .track .record .title .profile-panel.boat-info-form > .ant-form > .header > .text, .app .track .record .title .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input::placeholder, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .track .record .title input::placeholder, .app .track .record .title .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-placeholder, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .track .record .title .ant-select-selection-placeholder, .app .track .record .title .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .track .record .title input, .app .track .record .title .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-item, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .track .record .title .ant-select-selection-item, .app .track .record .title .profile .profile-panel > .ant-form > .ant-form-item > .ant-row > .ant-form-item-label > label, .app .profile .track .record .title .profile-panel > .ant-form > .ant-form-item > .ant-row > .ant-form-item-label > label, .app .track .record .title .modal.profile-hint-modal .hint > .hint-text > div, .modal.profile-hint-modal .app .track .record .title .hint > .hint-text > div, .app .track .record .title .modal.profile-error-modal .ant-modal-body > .text, .modal.profile-error-modal .app .track .record .title .ant-modal-body > .text, .app .track .record .title .auth .form > div > .data .input, .auth .form > div > .data .app .track .record .title .input, .app .track .record .title .auth .form > div > .data .input input, .auth .form > div > .data .input .app .track .record .title input, .app .track .record .title .auth .form > div > .data .input::placeholder, .auth .form > div > .data .app .track .record .title .input::placeholder, .app .track .record .title .list > .tongue-wrapper > .ant-list .ant-list-empty-text > span, .app .track .list > .tongue-wrapper > .ant-list .record .title .ant-list-empty-text > span {
  padding: 4px 8px;
}
.app .track .record .buttons {
  display: flex;
  justify-content: center;
  padding: 8px 12px;
  gap: 5px;
}
.app .track .record .buttons > button {
  flex-grow: 1;
}
.app .track .record .buttons > button.complete {
  background-color: #F13B3B;
}
.app .track .record .buttons > button.minimize {
  background-color: #FFFFFF;
  border: none;
}
.app .track .record.minimized {
  bottom: unset;
  top: 12px;
  right: 120px;
  width: fit-content;
  height: 64px;
  margin: 0;
  flex-direction: row;
  justify-content: center;
}
.app .track .record.minimized > .title {
  width: 140px;
}
.app .track .record.minimized > .title > svg {
  padding-right: 8px;
}
.app .track .save {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 20;
  left: 0;
  top: 0;
  background-color: #FFFFFF;
}
.app .track .save > .buttons {
  height: 48px;
}
.app .track .save > .buttons > button {
  margin: 12px 16px;
}
.app .track .save > .buttons > button.button-back {
  border: 0;
  width: unset;
}
.app .track .save > .buttons > button.button-close {
  float: right;
}
.app .track .save .container {
  height: calc(100% - 72px);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
}
.app .track .save .container > span:nth-child(2) {
  margin-top: 8px;
  margin-bottom: 24px;
}
.app .track .save .container input {
  margin-top: 8px;
  margin-bottom: 24px;
  padding: 14px 16px;
}
.app .track .save .container .colors {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.app .track .save .container .colors > div {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #FFFFFF;
}
.app .track .save .container .colors > div.selected {
  border-color: #0960A3;
}
.app .track .save .container .colors > div > div {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  margin: 4px;
}
.app .track .save .container .colors > div > div.color-0 {
  background-color: #124A74;
}
.app .track .save .container .colors > div > div.color-1 {
  background-color: #000000;
}
.app .track .save .container .colors > div > div.color-2 {
  background-color: #31CF13;
}
.app .track .save .container .colors > div > div.color-3 {
  background-color: #8926B3;
}
.app .track .save .container .colors > div > div.color-4 {
  background-color: #FF9812;
}
.app .track .save .container .colors > div > div.color-5 {
  background-color: #E01A4F;
}
.app .track .save .container .colors > div > div.color-6 {
  background-color: #001AFF;
}
.app .track .save .container > .buttons {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.app .track .save .container > .buttons > .empty-flex-grow-1 {
  flex-grow: 1;
}
.app .track .save .container > .buttons > button.button-delete {
  margin-top: 26px;
  color: #F13B3B;
  padding: 0;
  border: 0;
}
.app .track .save .container > .buttons > button.button-save {
  width: 100%;
}
.app .profile .main > .tongue-wrapper {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.app .profile .main > .tongue-wrapper > .row-header {
  padding: 24px 16px 8px 16px;
  color: #374151;
}
.app .profile .main > .tongue-wrapper > .row {
  min-height: 80px;
  margin: 0 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.app .profile .main > .tongue-wrapper > .row:hover {
  cursor: pointer;
  background-color: #F4F4F5;
}
.app .profile .main > .tongue-wrapper > .row .icon {
  min-width: 40px;
  min-height: 40px;
  background-color: #F5F7FA;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app .profile .main > .tongue-wrapper > .row > .description {
  flex-grow: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
}
.app .profile .main > .tongue-wrapper > .row > .description * {
  color: #374151 !important;
}
.app .profile .main > .tongue-wrapper > .row > .action {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 18px;
}
.app .profile .main > .tongue-wrapper > .row + .row {
  border-top: 1px solid #E9E9EB;
}
.app .profile .main > .tongue-wrapper > .row.captain {
  min-height: 88px;
}
.app .profile .main > .tongue-wrapper > .row.captain > .description {
  gap: 8px;
}
.app .profile .main > .tongue-wrapper > .row.boat-add {
  background-color: #EDF5FB;
  border-radius: 16px;
  padding: 16px;
}
.app .profile .main > .tongue-wrapper > .row.boat-add > .icon {
  background-color: #0960A3;
}
.app .profile .main > .tongue-wrapper > .row.boat-info {
  padding: 20px 0;
}
.app .profile .main > .tongue-wrapper > .row.boat-info > .description {
  padding: 0;
  max-width: calc(100% - 18px);
  gap: 8px;
}
.app .profile .main > .tongue-wrapper > .row.boat-info > .description > .header {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.app .profile .main > .tongue-wrapper > .row.boat-info > .description > .header > .title {
  padding: 0 16px;
}
.app .profile .main > .tongue-wrapper > .row.boat-info > .description > .text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 90%;
}
.app .profile .main > .tongue-wrapper > .row.boat-info > .description > .text > .key {
  color: #7E8591 !important;
}
.app .profile .main > .tongue-wrapper > .row.boat-info > .description > .text > .value {
  padding-left: 0.5em;
  padding-right: 1em;
}
.app .profile .profile-panel {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 20;
  left: 0;
  top: 0;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
}
.app .profile .profile-panel > .header {
  padding: 12px 16px 0 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  color: #17253C;
}
.app .profile .profile-panel > .header > div {
  flex-grow: 1;
}
.app .profile .profile-panel > .ant-form {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.app .profile .profile-panel > .ant-form .ant-form-item {
  margin: 0;
}
.app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row {
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
}
.app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row > .ant-form-item-label {
  padding-bottom: 8px;
  text-align: unset;
}
.app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row > .ant-form-item-label > label {
  height: 22px;
  color: #374151;
}
.app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-input-affix-wrapper, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-input-number-input-wrap > input {
  height: 48px;
}
.app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select {
  height: 48px;
  width: 100%;
}
.app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-item {
  color: #374151;
}
.app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row input::placeholder, .app .profile .profile-panel > .ant-form > .ant-form-item > .ant-row .ant-select-selection-placeholder {
  color: #A1A9B5;
}
.app .profile .profile-panel > .ant-form > .button-form-item {
  flex-grow: 1;
  align-content: flex-end;
  margin-bottom: 14px;
}
.app .profile .profile-panel > :not(.header) button {
  width: 100%;
  height: 48px;
  margin-top: 12px;
}
.app .profile .profile-panel > :not(.header) button.ant-btn-default {
  border: none;
  box-shadow: unset;
  color: #0960A3;
}
.app .profile .profile-panel > :not(.header) button.ant-btn-primary {
  background-color: #0960A3;
}
.app .profile .profile-panel > :not(.header) button.ant-btn-primary > span {
  color: #FFFFFF !important;
}
.app .profile .profile-panel > :not(.header) button:disabled {
  background-color: #E9E9EB;
}
.app .profile .profile-panel > :not(.header) button:disabled > span {
  color: #A1A9B5 !important;
}
.app .profile .profile-panel.boat-info-form > .steps {
  padding: 32px 16px;
}
.app .profile .profile-panel.boat-info-form > .steps.empty {
  padding: 25px 16px;
}
.app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-icon {
  line-height: 24px;
  height: 24px;
}
.app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-active .ant-steps-item-icon {
  color: #FFFFFF;
  background-color: #0960A3;
  border-color: #0960A3;
}
.app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-wait .ant-steps-item-icon {
  color: #909399;
  background-color: #F4F4F5;
  border-color: #E9E9EB;
}
.app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #DCEBF6;
  border-color: #C1D8EA;
}
.app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-finish .ant-steps-item-icon svg {
  color: #0960A3;
}
.app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-finish .ant-steps-item-title::after {
  background-color: #0960A3;
}
.app .profile .profile-panel.boat-info-form > .steps .ant-steps-item-title::after {
  top: 12px;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .header {
  padding: 0 16px 14px 16px;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .header > .text {
  padding-top: 4px;
  color: #7E8591;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .tracking-radio .ant-form-item-control-input {
  height: 48px;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row {
  display: flex;
  flex-direction: row;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row > div:first-child {
  flex-grow: 1;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row > div:first-child .ant-input-number {
  width: 100%;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row .switch {
  display: flex;
  flex-direction: row;
  padding-left: 12px;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row .switch > div {
  width: 73px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border: 1px solid #DCDFE6;
  color: #606266;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row .switch > div.left {
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row .switch > div.right {
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .dimension-row .switch > div.selected {
  background-color: #0960A3;
  color: #FFFFFF;
  border-color: #0960A3;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-form-item-control-input-content > div > .hint {
  width: fit-content;
  margin-top: 8px;
  color: #0960A3;
  cursor: pointer;
}
.app .profile .profile-panel.boat-info-form > .ant-form > .ant-form-item > .ant-row .ant-input-number {
  display: block;
  width: 100%;
}
.app .profile .profile-panel.boat-info-form > .ant-form .buttons {
  padding: 22px 16px 10px 16px;
  display: flex;
  flex-direction: row;
}
.app .profile .profile-panel.boat-info-form > .ant-form .buttons > * {
  width: 100%;
}
.app .profile .profile-panel.captain-form > .ant-form {
  margin-top: 14px;
}
.app .poi .main.tongue.show {
  min-width: 380px;
}
.app .poi .main > .tongue-wrapper > .header {
  display: flex;
  flex-wrap: nowrap;
  text-wrap: nowrap;
}
.app .poi .main > .tongue-wrapper > .header .add-button {
  flex-grow: 1;
}
.app .poi .main > .tongue-wrapper > .header .add-button > button {
  margin-left: 16px;
  height: 32px;
  background-color: rgba(145, 158, 171, 0.1215686275) !important;
  border: none;
}
.app .poi .main > .tongue-wrapper > .ant-collapse {
  height: 100%;
  display: flex;
  flex-direction: column;
  --height: 500px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item {
  padding: 0 15px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item.ant-collapse-item-disabled > .ant-collapse-header {
  cursor: default;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item.ant-collapse-item-active {
  flex-grow: 1;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item .ant-collapse-content-box {
  padding: 0;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item .ant-collapse-header {
  padding: 0;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item .list, .app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item .categories {
  height: var(--height);
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter {
  padding: 16px 5px 5px 5px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row {
  display: flex;
  flex-direction: row;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row:first-child {
  gap: 22px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row:first-child .ant-input-affix-wrapper {
  border-radius: 6px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row:first-child .ant-input-group-addon {
  display: none;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row:first-child > button {
  padding-inline: inherit;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row > .ant-slider {
  width: 100%;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .ant-collapse-header .filter > .row > .radius {
  width: 105px;
  max-width: 85px;
  text-align: right;
  overflow: hidden;
  height: 34px;
  line-height: 34px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .search-error {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .search-error > .error-text {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .search-error > .reload-button-container {
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .search-error > .reload-button-container > button {
  width: calc(100% - 32px);
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list {
  height: 100%;
  overflow: auto;
  flex-grow: 1;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item {
  padding: 16px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item:hover {
  background-color: #F4F4F5;
  cursor: pointer;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar {
  margin-right: 20px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color {
  display: block;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color.color-0 {
  background-color: #124A74;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color.color-1 {
  background-color: #000000;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color.color-2 {
  background-color: #31CF13;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color.color-3 {
  background-color: #8926B3;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color.color-4 {
  background-color: #FF9812;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color.color-5 {
  background-color: #E01A4F;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item .ant-list-item-meta-avatar .points-list-color.color-6 {
  background-color: #001AFF;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-empty-text {
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-empty-text > span {
  padding-top: 12px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:first-child .list > .ant-list .ant-list-item-action > li {
  width: 32px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) {
  border-top: 1px solid #DCDFE6;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2):not(.ant-collapse-item-active) > .ant-collapse-header:hover {
  cursor: pointer;
  background-color: #F4F4F5;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header {
  padding: 12px 0;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header .category > span {
  margin-left: 5px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header .category > .title {
  color: #7E8591;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header .category > .title:after {
  content: ":";
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header .category .selected .clear-icon {
  float: right;
  margin-right: 5px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .ant-collapse-header .category .selected .clear-icon > svg {
  width: 18px;
  height: 18px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category {
  width: calc(50% - 32px);
  padding: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  border-radius: 8px;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category:nth-child(2n) {
  float: right;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category:nth-child(2n+1) {
  float: left;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category:hover {
  background-color: #F4F4F5;
  cursor: pointer;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category.selected {
  background-color: #DCEBF6;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category > .icon {
  background-color: #124A74;
  margin-right: 8px;
  width: 60px;
  height: 60px;
  flex-grow: 0;
  flex-shrink: 0;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category > .icon.user {
  background-color: #D6B36A;
}
.app .poi .main > .tongue-wrapper > .ant-collapse .ant-collapse-item:nth-child(2) .categories > .category > .title {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.app .poi .dialog, .app .poi .new, .app .poi .track .start, .app .track .poi .start, .app .poi .track .record, .app .track .poi .record {
  width: calc(100% - 24px);
  position: absolute;
  bottom: 0;
  margin: 12px;
  background-color: #FFFFFF;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
}
.app .poi .new button {
  margin: 8px 8px 6px 8px;
}
.app .poi .new button.cancel {
  background-color: #FFFFFF;
  border: none;
  margin: 6px 8px 8px 8px;
}
.app .poi .save {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 20;
  left: 0;
  top: 0;
  background-color: #FFFFFF;
}
.app .poi .save > .buttons {
  height: 48px;
}
.app .poi .save > .buttons > button {
  margin: 12px 16px;
}
.app .poi .save > .buttons > button.button-back {
  border: 0;
  width: unset;
}
.app .poi .save > .buttons > button.button-close {
  float: right;
}
.app .poi .save .container {
  height: calc(100% - 72px);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
}
.app .poi .save .container > span:nth-child(2) {
  margin-top: 8px;
  margin-bottom: 24px;
}
.app .poi .save .container input, .app .poi .save .container textarea {
  margin-top: 8px;
  margin-bottom: 24px;
  padding: 14px 16px;
}
.app .poi .save .container .colors {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.app .poi .save .container .colors > div {
  padding: 4px;
  border-radius: 50%;
  border: 1px solid #FFFFFF;
}
.app .poi .save .container .colors > div.selected {
  border-color: #0960A3;
}
.app .poi .save .container .colors > div > span.color-0 {
  background-color: #124A74;
}
.app .poi .save .container .colors > div > span.color-1 {
  background-color: #000000;
}
.app .poi .save .container .colors > div > span.color-2 {
  background-color: #31CF13;
}
.app .poi .save .container .colors > div > span.color-3 {
  background-color: #8926B3;
}
.app .poi .save .container .colors > div > span.color-4 {
  background-color: #FF9812;
}
.app .poi .save .container .colors > div > span.color-5 {
  background-color: #E01A4F;
}
.app .poi .save .container .colors > div > span.color-6 {
  background-color: #001AFF;
}
.app .poi .save .container > .buttons {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.app .poi .save .container > .buttons > .empty-flex-grow-1 {
  flex-grow: 1;
}
.app .poi .save .container > .buttons > button.button-delete {
  margin-top: 26px;
  color: #F13B3B;
  padding: 0;
  border: 0;
}
.app .poi .save .container > .buttons > button.button-save {
  width: 100%;
}
.app .poi .view .tongue-wrapper > .point {
  display: flex;
  padding: 24px 16px 5px 16px;
  flex-grow: 1;
}
.app .poi .view .tongue-wrapper > .point > .point-data {
  flex-grow: 1;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon {
  min-width: 32px;
  margin-right: 20px;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon.color-0 {
  background-color: #124A74;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon.color-1 {
  background-color: #000000;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon.color-2 {
  background-color: #31CF13;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon.color-3 {
  background-color: #8926B3;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon.color-4 {
  background-color: #FF9812;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon.color-5 {
  background-color: #E01A4F;
}
.app .poi .view .tongue-wrapper > .point > .point-data .title .point-icon.color-6 {
  background-color: #001AFF;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text {
  max-height: 280px;
  overflow-y: auto;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block {
  padding: 10px;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block:not(.contact) > .row.value > p, .app .poi .view .tongue-wrapper > .point > .point-data .text > .block:not(.contact) > .row.value a {
  border-bottom: 1px solid #DCDFE6;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block.contact {
  background-color: #F5F7FA;
  border-radius: 8px;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block > .row {
  padding: 3px 0;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block > .row.code {
  padding-bottom: 7px;
  color: #17253C;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block > .row.code:after {
  content: ":";
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block > .row.value > a {
  color: #124A74;
  text-decoration: none;
}
.app .poi .view .tongue-wrapper > .point > .point-data .text > .block > .row.value > p, .app .poi .view .tongue-wrapper > .point > .point-data .text > .block > .row.value a {
  display: block;
  margin: 0;
  padding: 3px 0;
}
.app .poi .view .tongue-wrapper > .buttons {
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.app .poi .view .tongue-wrapper > .buttons > button {
  margin: 14px;
  border: 0;
  padding: 0;
}
.app .poi .view .tongue-wrapper > .buttons > button.button-error, .app .poi .view .tongue-wrapper > .buttons > button.button-publish {
  color: #17253C;
}
.app .poi .view .tongue-wrapper > .buttons > button.button-error svg, .app .poi .view .tongue-wrapper > .buttons > button.button-publish svg {
  width: 18px;
  height: 18px;
}
.app .poi .view .tongue-wrapper > .buttons > button.button-error {
  color: #F13B3B;
}
.app .new-point {
  position: absolute;
  right: calc(var(--map-width) / 2);
  top: calc(var(--map-height) / 2);
  transform: translate(50%) translateY(-100%);
  background-size: cover;
  z-index: 1000;
  width: 50px;
  height: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.app .layer .main.tongue.show {
  min-width: 350px;
}
.app .layer .main > .tongue-wrapper > .ant-list {
  margin-top: 20px;
  height: 100%;
  overflow: auto;
}
.app .layer .main > .tongue-wrapper > .ant-list .ant-list-item {
  cursor: pointer;
  padding: 16px;
}
.app .layer .main > .tongue-wrapper > .ant-list .ant-list-item .ant-list-item-meta-avatar {
  margin-right: 20px;
}
.app .layer .main > .tongue-wrapper > .ant-list .ant-list-item .ant-list-item-meta-avatar > .icon {
  background-color: #124A74;
  margin-right: 20px;
}
.app .layer .main > .tongue-wrapper > .ant-list .ant-list-item .ant-list-item-meta-avatar > .icon.user {
  background-color: #D6B36A;
}
.app .layer .main > .tongue-wrapper > .ant-list .ant-list-item-action > li {
  width: 32px;
}
.app .data {
  z-index: 10;
  position: absolute;
  width: 110px;
  margin-right: 12px;
  right: 0;
  top: 12px;
}
.app .data > div {
  background-color: #FFFFFF;
  height: 64px;
  border-radius: 20px;
  text-align: center;
  padding: 0 16px;
}
.app .data > div > div:first-child {
  padding-top: 8px;
}
.app .data > div .speed-value {
  text-align: left;
  padding-right: 5px;
}
.app .adapter-data .widget {
  position: absolute;
  background-color: white;
  z-index: 10;
  top: 100px;
  padding: 10px;
  border-radius: 20px;
  text-align: center;
}
.app .adapter-data .widget .value {
  text-align: left;
  padding-right: 5px;
}

@media screen and (orientation: landscape) {
  .auth > .form {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0;
  }
  .auth > .form > div {
    min-width: 70%;
  }
  .auth > .form > div.logo {
    min-width: 180px;
    flex-basis: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .auth > .form > div.logo > svg {
    width: 130px;
    height: 130px;
  }
  .auth > .form > div.login {
    padding-top: 5px;
    overflow: auto;
    max-width: min(70%, 600px);
    flex-basis: calc(100% - 70px);
  }
  .auth > .form > div.login .welcome-text {
    padding-top: 0;
  }
  .auth > .form > div.login > .data {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .auth > .form > div.login > .data > .loader {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .auth > .form > div.login > .data > .loader > div:nth-child(2) {
    width: 200px;
    height: 100px;
  }
  .auth > .form > div.footer {
    padding: 15px 0;
  }
  .track {
    display: none !important;
  }
  .menu {
    display: none !important;
  }
  .profile {
    display: none !important;
  }
}
.tablet-styles.modal, .modal.ant-notification-tablet, .modal.modal-tablet, .modal.device-type-tablet {
  width: 432px;
  margin: unset;
}
.tablet-styles.modal .ant-modal-content, .modal.ant-notification-tablet .ant-modal-content, .modal.modal-tablet .ant-modal-content, .modal.device-type-tablet .ant-modal-content {
  padding: 40px;
}
.tablet-styles.modal .ant-modal-content .ant-modal-footer > .buttons, .modal.ant-notification-tablet .ant-modal-content .ant-modal-footer > .buttons, .modal.modal-tablet .ant-modal-content .ant-modal-footer > .buttons, .modal.device-type-tablet .ant-modal-content .ant-modal-footer > .buttons {
  flex-direction: row-reverse;
  gap: 28px;
}
.tablet-styles.modal.confirm-dialog .ant-modal-content > .ant-modal-header > .ant-modal-title, .modal.confirm-dialog.ant-notification-tablet .ant-modal-content > .ant-modal-header > .ant-modal-title, .modal.confirm-dialog.modal-tablet .ant-modal-content > .ant-modal-header > .ant-modal-title, .modal.confirm-dialog.device-type-tablet .ant-modal-content > .ant-modal-header > .ant-modal-title {
  padding: 0 10px;
  text-align: center;
}
.tablet-styles .auth > .form, .ant-notification-tablet .auth > .form, .modal-tablet .auth > .form, .device-type-tablet .auth > .form {
  flex-wrap: nowrap;
  justify-content: center;
  width: 548px;
}
.tablet-styles .auth > .form > div.logo > svg, .ant-notification-tablet .auth > .form > div.logo > svg, .modal-tablet .auth > .form > div.logo > svg, .device-type-tablet .auth > .form > div.logo > svg {
  width: 106px;
  height: 106px;
}
.tablet-styles .auth > .form > div.login, .ant-notification-tablet .auth > .form > div.login, .modal-tablet .auth > .form > div.login, .device-type-tablet .auth > .form > div.login {
  flex-grow: 0;
}
.tablet-styles .auth > .form > div.login .data, .ant-notification-tablet .auth > .form > div.login .data, .modal-tablet .auth > .form > div.login .data, .device-type-tablet .auth > .form > div.login .data {
  flex-grow: 0;
  margin-bottom: 34px;
}
.tablet-styles .auth > .form > div.login .data > .loader, .ant-notification-tablet .auth > .form > div.login .data > .loader, .modal-tablet .auth > .form > div.login .data > .loader, .device-type-tablet .auth > .form > div.login .data > .loader {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tablet-styles .auth > .form > div.login .data > .loader > div:nth-child(2), .ant-notification-tablet .auth > .form > div.login .data > .loader > div:nth-child(2), .modal-tablet .auth > .form > div.login .data > .loader > div:nth-child(2), .device-type-tablet .auth > .form > div.login .data > .loader > div:nth-child(2) {
  width: 300px;
  height: 170px;
}
.tablet-styles .menu, .ant-notification-tablet .menu, .modal-tablet .menu, .device-type-tablet .menu {
  width: 650px;
  height: 96px;
}
.tablet-styles .menu.with-pagination, .ant-notification-tablet .menu.with-pagination, .modal-tablet .menu.with-pagination, .device-type-tablet .menu.with-pagination {
  height: 126px;
}
.tablet-styles .menu > .pages > .items, .ant-notification-tablet .menu > .pages > .items, .modal-tablet .menu > .pages > .items, .device-type-tablet .menu > .pages > .items {
  gap: 65px;
  height: 68px;
  padding: 16px 0 12px 0;
}
.tablet-styles .menu > .pages > .items > div > .item, .ant-notification-tablet .menu > .pages > .items > div > .item, .modal-tablet .menu > .pages > .items > div > .item, .device-type-tablet .menu > .pages > .items > div > .item {
  width: 48px !important;
  height: 48px !important;
}
.tablet-styles .tongue, .ant-notification-tablet .tongue, .modal-tablet .tongue, .device-type-tablet .tongue {
  flex-direction: row-reverse;
  max-width: 0;
  min-width: 0;
  max-height: unset;
  border-radius: 12px;
  bottom: unset;
  top: 0;
  transition: max-width 0.5s, min-width 0.5s;
  margin: 12px 0 20px 12px;
}
.tablet-styles .tongue.full, .ant-notification-tablet .tongue.full, .modal-tablet .tongue.full, .device-type-tablet .tongue.full {
  height: calc(100% - 32px);
}
.tablet-styles .tongue.fit-content, .ant-notification-tablet .tongue.fit-content, .modal-tablet .tongue.fit-content, .device-type-tablet .tongue.fit-content {
  max-height: fit-content;
}
.tablet-styles .tongue.show, .ant-notification-tablet .tongue.show, .modal-tablet .tongue.show, .device-type-tablet .tongue.show {
  max-width: 30% !important;
  min-width: 330px;
}
.tablet-styles .tongue.show.full, .ant-notification-tablet .tongue.show.full, .modal-tablet .tongue.show.full, .device-type-tablet .tongue.show.full {
  max-height: calc(100% - 32px);
}
.tablet-styles .tongue.show.fit-content, .ant-notification-tablet .tongue.show.fit-content, .modal-tablet .tongue.show.fit-content, .device-type-tablet .tongue.show.fit-content {
  max-height: fit-content;
}
.tablet-styles .tongue > .swipe-toggle, .ant-notification-tablet .tongue > .swipe-toggle, .modal-tablet .tongue > .swipe-toggle, .device-type-tablet .tongue > .swipe-toggle {
  height: auto;
  width: 0;
  display: flex;
  justify-content: left;
  align-items: center;
}
.tablet-styles .tongue > .swipe-toggle > div, .ant-notification-tablet .tongue > .swipe-toggle > div, .modal-tablet .tongue > .swipe-toggle > div, .device-type-tablet .tongue > .swipe-toggle > div {
  position: relative;
  left: -12px;
  height: 30px;
  width: unset;
  min-height: 30px;
  min-width: 4px;
}
.tablet-styles .tongue > .tongue-wrapper, .ant-notification-tablet .tongue > .tongue-wrapper, .modal-tablet .tongue > .tongue-wrapper, .device-type-tablet .tongue > .tongue-wrapper {
  min-width: 320px;
}
.tablet-styles .tongue > .tongue-wrapper > .header, .ant-notification-tablet .tongue > .tongue-wrapper > .header, .modal-tablet .tongue > .tongue-wrapper > .header, .device-type-tablet .tongue > .tongue-wrapper > .header {
  margin-top: 16px;
}
.tablet-styles .track .start, .ant-notification-tablet .track .start, .modal-tablet .track .start, .device-type-tablet .track .start {
  width: 350px;
  left: calc(50% - 187px);
}
.tablet-styles .track .save, .ant-notification-tablet .track .save, .modal-tablet .track .save, .device-type-tablet .track .save {
  width: 520px;
  height: 428px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
}
.tablet-styles .track .save > .buttons, .ant-notification-tablet .track .save > .buttons, .modal-tablet .track .save > .buttons, .device-type-tablet .track .save > .buttons {
  height: 40px;
}
.tablet-styles .track .save .container, .ant-notification-tablet .track .save .container, .modal-tablet .track .save .container, .device-type-tablet .track .save .container {
  padding: 0 40px 40px 40px;
  width: calc(100% - 80px);
  height: calc(100% - 88px);
}
.tablet-styles .track .save .container > div:first-child, .ant-notification-tablet .track .save .container > div:first-child, .modal-tablet .track .save .container > div:first-child, .device-type-tablet .track .save .container > div:first-child {
  margin-bottom: unset;
}
.tablet-styles .track .save .container > .buttons, .ant-notification-tablet .track .save .container > .buttons, .modal-tablet .track .save .container > .buttons, .device-type-tablet .track .save .container > .buttons {
  flex-direction: row;
  align-items: flex-end;
}
.tablet-styles .track .save .container > .buttons > button.button-delete, .ant-notification-tablet .track .save .container > .buttons > button.button-delete, .modal-tablet .track .save .container > .buttons > button.button-delete, .device-type-tablet .track .save .container > .buttons > button.button-delete {
  margin-top: unset;
}
.tablet-styles .track .save .container > .buttons > button.button-save, .ant-notification-tablet .track .save .container > .buttons > button.button-save, .modal-tablet .track .save .container > .buttons > button.button-save, .device-type-tablet .track .save .container > .buttons > button.button-save {
  width: unset;
}
.tablet-styles .poi .new, .ant-notification-tablet .poi .new, .modal-tablet .poi .new, .device-type-tablet .poi .new {
  width: 350px;
  left: calc(50% - 187px);
}
.tablet-styles .poi .save, .ant-notification-tablet .poi .save, .modal-tablet .poi .save, .device-type-tablet .poi .save {
  width: 520px;
  height: 560px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
}
.tablet-styles .poi .save > .buttons, .ant-notification-tablet .poi .save > .buttons, .modal-tablet .poi .save > .buttons, .device-type-tablet .poi .save > .buttons {
  height: 40px;
}
.tablet-styles .poi .save .container, .ant-notification-tablet .poi .save .container, .modal-tablet .poi .save .container, .device-type-tablet .poi .save .container {
  padding: 0 40px 40px 40px;
  width: calc(100% - 80px);
  height: calc(100% - 88px);
}
.tablet-styles .poi .save .container > div:first-child, .ant-notification-tablet .poi .save .container > div:first-child, .modal-tablet .poi .save .container > div:first-child, .device-type-tablet .poi .save .container > div:first-child {
  margin-bottom: unset;
}
.tablet-styles .poi .save .container > .buttons, .ant-notification-tablet .poi .save .container > .buttons, .modal-tablet .poi .save .container > .buttons, .device-type-tablet .poi .save .container > .buttons {
  flex-direction: row;
  align-items: flex-end;
}
.tablet-styles .poi .save .container > .buttons > button.button-delete, .ant-notification-tablet .poi .save .container > .buttons > button.button-delete, .modal-tablet .poi .save .container > .buttons > button.button-delete, .device-type-tablet .poi .save .container > .buttons > button.button-delete {
  margin-top: unset;
}
.tablet-styles .poi .save .container > .buttons > button.button-save, .ant-notification-tablet .poi .save .container > .buttons > button.button-save, .modal-tablet .poi .save .container > .buttons > button.button-save, .device-type-tablet .poi .save .container > .buttons > button.button-save {
  width: unset;
}
.tablet-styles .poi .view .tongue-wrapper .point > .point-data .text, .ant-notification-tablet .poi .view .tongue-wrapper .point > .point-data .text, .modal-tablet .poi .view .tongue-wrapper .point > .point-data .text, .device-type-tablet .poi .view .tongue-wrapper .point > .point-data .text {
  max-height: 700px;
}
.tablet-styles .adapter.tongue.show, .ant-notification-tablet .adapter.tongue.show, .modal-tablet .adapter.tongue.show, .device-type-tablet .adapter.tongue.show {
  min-width: 400px !important;
}
.tablet-styles .profile > .tongue.show, .ant-notification-tablet .profile > .tongue.show, .modal-tablet .profile > .tongue.show, .device-type-tablet .profile > .tongue.show {
  min-width: 370px !important;
}
.tablet-styles .profile > .tongue.main > .tongue-wrapper > .header, .ant-notification-tablet .profile > .tongue.main > .tongue-wrapper > .header, .modal-tablet .profile > .tongue.main > .tongue-wrapper > .header, .device-type-tablet .profile > .tongue.main > .tongue-wrapper > .header {
  justify-content: flex-end;
}
.tablet-styles .profile > .tongue.main > .tongue-wrapper > .row, .ant-notification-tablet .profile > .tongue.main > .tongue-wrapper > .row, .modal-tablet .profile > .tongue.main > .tongue-wrapper > .row, .device-type-tablet .profile > .tongue.main > .tongue-wrapper > .row {
  min-height: 78px;
}
.tablet-styles .profile > .tongue.main > .tongue-wrapper > .row.boat-info, .ant-notification-tablet .profile > .tongue.main > .tongue-wrapper > .row.boat-info, .modal-tablet .profile > .tongue.main > .tongue-wrapper > .row.boat-info, .device-type-tablet .profile > .tongue.main > .tongue-wrapper > .row.boat-info {
  padding: 16px 0;
}
.tablet-styles .profile > .tongue > .tongue-wrapper > .header, .ant-notification-tablet .profile > .tongue > .tongue-wrapper > .header, .modal-tablet .profile > .tongue > .tongue-wrapper > .header, .device-type-tablet .profile > .tongue > .tongue-wrapper > .header {
  display: flex;
  flex-direction: row;
}
.tablet-styles .profile > .tongue > .tongue-wrapper > .header > .title, .ant-notification-tablet .profile > .tongue > .tongue-wrapper > .header > .title, .modal-tablet .profile > .tongue > .tongue-wrapper > .header > .title, .device-type-tablet .profile > .tongue > .tongue-wrapper > .header > .title {
  flex-grow: 1;
  text-align: right;
}
.tablet-styles .profile > .tongue .profile-panel, .ant-notification-tablet .profile > .tongue .profile-panel, .modal-tablet .profile > .tongue .profile-panel, .device-type-tablet .profile > .tongue .profile-panel {
  position: unset;
  z-index: unset;
  top: unset;
  left: unset;
}
.tablet-styles .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col, .ant-notification-tablet .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col, .modal-tablet .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col, .device-type-tablet .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col {
  min-height: unset;
}
@media screen and (orientation: landscape) {
  .tablet-styles .auth > .form > div, .ant-notification-tablet .auth > .form > div, .modal-tablet .auth > .form > div, .device-type-tablet .auth > .form > div {
    flex-basis: unset;
    max-width: unset;
    overflow: auto;
  }
  .tablet-styles .menu, .ant-notification-tablet .menu, .modal-tablet .menu, .device-type-tablet .menu {
    display: block !important;
  }
  .tablet-styles .track, .ant-notification-tablet .track, .modal-tablet .track, .device-type-tablet .track {
    display: unset !important;
  }
  .tablet-styles .profile, .ant-notification-tablet .profile, .modal-tablet .profile, .device-type-tablet .profile {
    display: unset !important;
  }
  .tablet-styles .poi .view .tongue-wrapper .point > .point-data .text, .ant-notification-tablet .poi .view .tongue-wrapper .point > .point-data .text, .modal-tablet .poi .view .tongue-wrapper .point > .point-data .text, .device-type-tablet .poi .view .tongue-wrapper .point > .point-data .text {
    max-height: 500px;
  }
}

.desktop-styles.modal, .modal.ant-notification-desktop, .modal.modal-desktop, .modal.device-type-desktop {
  width: 432px;
  margin: unset;
}
.desktop-styles.modal .ant-modal-content, .modal.ant-notification-desktop .ant-modal-content, .modal.modal-desktop .ant-modal-content, .modal.device-type-desktop .ant-modal-content {
  padding: 40px;
}
.desktop-styles.modal .ant-modal-content .ant-modal-footer > .buttons, .modal.ant-notification-desktop .ant-modal-content .ant-modal-footer > .buttons, .modal.modal-desktop .ant-modal-content .ant-modal-footer > .buttons, .modal.device-type-desktop .ant-modal-content .ant-modal-footer > .buttons {
  flex-direction: row-reverse;
  gap: 28px;
}
.desktop-styles.modal.confirm-dialog .ant-modal-content > .ant-modal-header > .ant-modal-title, .modal.confirm-dialog.ant-notification-desktop .ant-modal-content > .ant-modal-header > .ant-modal-title, .modal.confirm-dialog.modal-desktop .ant-modal-content > .ant-modal-header > .ant-modal-title, .modal.confirm-dialog.device-type-desktop .ant-modal-content > .ant-modal-header > .ant-modal-title {
  padding: 0 10px;
  text-align: center;
}
.desktop-styles .auth > .form, .ant-notification-desktop .auth > .form, .modal-desktop .auth > .form, .device-type-desktop .auth > .form {
  flex-wrap: nowrap;
  justify-content: center;
  width: 548px;
}
.desktop-styles .auth > .form > div.logo > svg, .ant-notification-desktop .auth > .form > div.logo > svg, .modal-desktop .auth > .form > div.logo > svg, .device-type-desktop .auth > .form > div.logo > svg {
  width: 106px;
  height: 106px;
}
.desktop-styles .auth > .form > div.login, .ant-notification-desktop .auth > .form > div.login, .modal-desktop .auth > .form > div.login, .device-type-desktop .auth > .form > div.login {
  flex-grow: 0;
}
.desktop-styles .auth > .form > div.login .data, .ant-notification-desktop .auth > .form > div.login .data, .modal-desktop .auth > .form > div.login .data, .device-type-desktop .auth > .form > div.login .data {
  flex-grow: 0;
  margin-bottom: 34px;
}
.desktop-styles .auth > .form > div.login .data > .loader, .ant-notification-desktop .auth > .form > div.login .data > .loader, .modal-desktop .auth > .form > div.login .data > .loader, .device-type-desktop .auth > .form > div.login .data > .loader {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.desktop-styles .auth > .form > div.login .data > .loader > div:nth-child(2), .ant-notification-desktop .auth > .form > div.login .data > .loader > div:nth-child(2), .modal-desktop .auth > .form > div.login .data > .loader > div:nth-child(2), .device-type-desktop .auth > .form > div.login .data > .loader > div:nth-child(2) {
  width: 300px;
  height: 170px;
}
.desktop-styles .menu, .ant-notification-desktop .menu, .modal-desktop .menu, .device-type-desktop .menu {
  width: 650px;
  height: 96px;
}
.desktop-styles .menu.with-pagination, .ant-notification-desktop .menu.with-pagination, .modal-desktop .menu.with-pagination, .device-type-desktop .menu.with-pagination {
  height: 126px;
}
.desktop-styles .menu > .pages > .items, .ant-notification-desktop .menu > .pages > .items, .modal-desktop .menu > .pages > .items, .device-type-desktop .menu > .pages > .items {
  gap: 65px;
  height: 68px;
  padding: 16px 0 12px 0;
}
.desktop-styles .menu > .pages > .items > div > .item, .ant-notification-desktop .menu > .pages > .items > div > .item, .modal-desktop .menu > .pages > .items > div > .item, .device-type-desktop .menu > .pages > .items > div > .item {
  width: 48px !important;
  height: 48px !important;
}
.desktop-styles .tongue, .ant-notification-desktop .tongue, .modal-desktop .tongue, .device-type-desktop .tongue {
  flex-direction: row-reverse;
  max-width: 0;
  min-width: 0;
  max-height: unset;
  border-radius: 12px;
  bottom: unset;
  top: 0;
  transition: max-width 0.5s, min-width 0.5s;
  margin: 12px 0 20px 12px;
}
.desktop-styles .tongue.full, .ant-notification-desktop .tongue.full, .modal-desktop .tongue.full, .device-type-desktop .tongue.full {
  height: calc(100% - 32px);
}
.desktop-styles .tongue.fit-content, .ant-notification-desktop .tongue.fit-content, .modal-desktop .tongue.fit-content, .device-type-desktop .tongue.fit-content {
  max-height: fit-content;
}
.desktop-styles .tongue.show, .ant-notification-desktop .tongue.show, .modal-desktop .tongue.show, .device-type-desktop .tongue.show {
  max-width: 30% !important;
  min-width: 330px;
}
.desktop-styles .tongue.show.full, .ant-notification-desktop .tongue.show.full, .modal-desktop .tongue.show.full, .device-type-desktop .tongue.show.full {
  max-height: calc(100% - 32px);
}
.desktop-styles .tongue.show.fit-content, .ant-notification-desktop .tongue.show.fit-content, .modal-desktop .tongue.show.fit-content, .device-type-desktop .tongue.show.fit-content {
  max-height: fit-content;
}
.desktop-styles .tongue > .swipe-toggle, .ant-notification-desktop .tongue > .swipe-toggle, .modal-desktop .tongue > .swipe-toggle, .device-type-desktop .tongue > .swipe-toggle {
  height: auto;
  width: 0;
  display: flex;
  justify-content: left;
  align-items: center;
}
.desktop-styles .tongue > .swipe-toggle > div, .ant-notification-desktop .tongue > .swipe-toggle > div, .modal-desktop .tongue > .swipe-toggle > div, .device-type-desktop .tongue > .swipe-toggle > div {
  position: relative;
  left: -12px;
  height: 30px;
  width: unset;
  min-height: 30px;
  min-width: 4px;
}
.desktop-styles .tongue > .tongue-wrapper, .ant-notification-desktop .tongue > .tongue-wrapper, .modal-desktop .tongue > .tongue-wrapper, .device-type-desktop .tongue > .tongue-wrapper {
  min-width: 320px;
}
.desktop-styles .tongue > .tongue-wrapper > .header, .ant-notification-desktop .tongue > .tongue-wrapper > .header, .modal-desktop .tongue > .tongue-wrapper > .header, .device-type-desktop .tongue > .tongue-wrapper > .header {
  margin-top: 16px;
}
.desktop-styles .track .start, .ant-notification-desktop .track .start, .modal-desktop .track .start, .device-type-desktop .track .start {
  width: 350px;
  left: calc(50% - 187px);
}
.desktop-styles .track .save, .ant-notification-desktop .track .save, .modal-desktop .track .save, .device-type-desktop .track .save {
  width: 520px;
  height: 428px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
}
.desktop-styles .track .save > .buttons, .ant-notification-desktop .track .save > .buttons, .modal-desktop .track .save > .buttons, .device-type-desktop .track .save > .buttons {
  height: 40px;
}
.desktop-styles .track .save .container, .ant-notification-desktop .track .save .container, .modal-desktop .track .save .container, .device-type-desktop .track .save .container {
  padding: 0 40px 40px 40px;
  width: calc(100% - 80px);
  height: calc(100% - 88px);
}
.desktop-styles .track .save .container > div:first-child, .ant-notification-desktop .track .save .container > div:first-child, .modal-desktop .track .save .container > div:first-child, .device-type-desktop .track .save .container > div:first-child {
  margin-bottom: unset;
}
.desktop-styles .track .save .container > .buttons, .ant-notification-desktop .track .save .container > .buttons, .modal-desktop .track .save .container > .buttons, .device-type-desktop .track .save .container > .buttons {
  flex-direction: row;
  align-items: flex-end;
}
.desktop-styles .track .save .container > .buttons > button.button-delete, .ant-notification-desktop .track .save .container > .buttons > button.button-delete, .modal-desktop .track .save .container > .buttons > button.button-delete, .device-type-desktop .track .save .container > .buttons > button.button-delete {
  margin-top: unset;
}
.desktop-styles .track .save .container > .buttons > button.button-save, .ant-notification-desktop .track .save .container > .buttons > button.button-save, .modal-desktop .track .save .container > .buttons > button.button-save, .device-type-desktop .track .save .container > .buttons > button.button-save {
  width: unset;
}
.desktop-styles .poi .new, .ant-notification-desktop .poi .new, .modal-desktop .poi .new, .device-type-desktop .poi .new {
  width: 350px;
  left: calc(50% - 187px);
}
.desktop-styles .poi .save, .ant-notification-desktop .poi .save, .modal-desktop .poi .save, .device-type-desktop .poi .save {
  width: 520px;
  height: 560px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
}
.desktop-styles .poi .save > .buttons, .ant-notification-desktop .poi .save > .buttons, .modal-desktop .poi .save > .buttons, .device-type-desktop .poi .save > .buttons {
  height: 40px;
}
.desktop-styles .poi .save .container, .ant-notification-desktop .poi .save .container, .modal-desktop .poi .save .container, .device-type-desktop .poi .save .container {
  padding: 0 40px 40px 40px;
  width: calc(100% - 80px);
  height: calc(100% - 88px);
}
.desktop-styles .poi .save .container > div:first-child, .ant-notification-desktop .poi .save .container > div:first-child, .modal-desktop .poi .save .container > div:first-child, .device-type-desktop .poi .save .container > div:first-child {
  margin-bottom: unset;
}
.desktop-styles .poi .save .container > .buttons, .ant-notification-desktop .poi .save .container > .buttons, .modal-desktop .poi .save .container > .buttons, .device-type-desktop .poi .save .container > .buttons {
  flex-direction: row;
  align-items: flex-end;
}
.desktop-styles .poi .save .container > .buttons > button.button-delete, .ant-notification-desktop .poi .save .container > .buttons > button.button-delete, .modal-desktop .poi .save .container > .buttons > button.button-delete, .device-type-desktop .poi .save .container > .buttons > button.button-delete {
  margin-top: unset;
}
.desktop-styles .poi .save .container > .buttons > button.button-save, .ant-notification-desktop .poi .save .container > .buttons > button.button-save, .modal-desktop .poi .save .container > .buttons > button.button-save, .device-type-desktop .poi .save .container > .buttons > button.button-save {
  width: unset;
}
.desktop-styles .poi .view .tongue-wrapper .point > .point-data .text, .ant-notification-desktop .poi .view .tongue-wrapper .point > .point-data .text, .modal-desktop .poi .view .tongue-wrapper .point > .point-data .text, .device-type-desktop .poi .view .tongue-wrapper .point > .point-data .text {
  max-height: 700px;
}
.desktop-styles .adapter.tongue.show, .ant-notification-desktop .adapter.tongue.show, .modal-desktop .adapter.tongue.show, .device-type-desktop .adapter.tongue.show {
  min-width: 400px !important;
}
.desktop-styles .profile > .tongue.show, .ant-notification-desktop .profile > .tongue.show, .modal-desktop .profile > .tongue.show, .device-type-desktop .profile > .tongue.show {
  min-width: 370px !important;
}
.desktop-styles .profile > .tongue.main > .tongue-wrapper > .header, .ant-notification-desktop .profile > .tongue.main > .tongue-wrapper > .header, .modal-desktop .profile > .tongue.main > .tongue-wrapper > .header, .device-type-desktop .profile > .tongue.main > .tongue-wrapper > .header {
  justify-content: flex-end;
}
.desktop-styles .profile > .tongue.main > .tongue-wrapper > .row, .ant-notification-desktop .profile > .tongue.main > .tongue-wrapper > .row, .modal-desktop .profile > .tongue.main > .tongue-wrapper > .row, .device-type-desktop .profile > .tongue.main > .tongue-wrapper > .row {
  min-height: 78px;
}
.desktop-styles .profile > .tongue.main > .tongue-wrapper > .row.boat-info, .ant-notification-desktop .profile > .tongue.main > .tongue-wrapper > .row.boat-info, .modal-desktop .profile > .tongue.main > .tongue-wrapper > .row.boat-info, .device-type-desktop .profile > .tongue.main > .tongue-wrapper > .row.boat-info {
  padding: 16px 0;
}
.desktop-styles .profile > .tongue > .tongue-wrapper > .header, .ant-notification-desktop .profile > .tongue > .tongue-wrapper > .header, .modal-desktop .profile > .tongue > .tongue-wrapper > .header, .device-type-desktop .profile > .tongue > .tongue-wrapper > .header {
  display: flex;
  flex-direction: row;
}
.desktop-styles .profile > .tongue > .tongue-wrapper > .header > .title, .ant-notification-desktop .profile > .tongue > .tongue-wrapper > .header > .title, .modal-desktop .profile > .tongue > .tongue-wrapper > .header > .title, .device-type-desktop .profile > .tongue > .tongue-wrapper > .header > .title {
  flex-grow: 1;
  text-align: right;
}
.desktop-styles .profile > .tongue .profile-panel, .ant-notification-desktop .profile > .tongue .profile-panel, .modal-desktop .profile > .tongue .profile-panel, .device-type-desktop .profile > .tongue .profile-panel {
  position: unset;
  z-index: unset;
  top: unset;
  left: unset;
}
.desktop-styles .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col, .ant-notification-desktop .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col, .modal-desktop .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col, .device-type-desktop .profile > .tongue .profile-panel > .ant-form .ant-row > .ant-col {
  min-height: unset;
}
.desktop-styles .auth, .ant-notification-desktop .auth, .modal-desktop .auth, .device-type-desktop .auth {
  flex-direction: row;
  padding: 24px !important;
  width: calc(100% - 48px);
  height: calc(100% - 48px);
}
.desktop-styles .auth > div, .ant-notification-desktop .auth > div, .modal-desktop .auth > div, .device-type-desktop .auth > div {
  flex: 1;
}
.desktop-styles .auth > .form, .ant-notification-desktop .auth > .form, .modal-desktop .auth > .form, .device-type-desktop .auth > .form {
  width: unset;
  align-items: center;
}
.desktop-styles .auth > .form > div, .ant-notification-desktop .auth > .form > div, .modal-desktop .auth > .form > div, .device-type-desktop .auth > .form > div {
  max-width: 448px !important;
}
.desktop-styles .auth > .auth-img, .ant-notification-desktop .auth > .auth-img, .modal-desktop .auth > .auth-img, .device-type-desktop .auth > .auth-img {
  display: none;
}
.desktop-styles .app, .ant-notification-desktop .app, .modal-desktop .app, .device-type-desktop .app {
  --map-width: calc(100% - 60px);
}
.desktop-styles .app .map-element, .ant-notification-desktop .app .map-element, .modal-desktop .app .map-element, .device-type-desktop .app .map-element {
  float: right;
}
.desktop-styles .app .left-menu, .ant-notification-desktop .app .left-menu, .modal-desktop .app .left-menu, .device-type-desktop .app .left-menu {
  width: 60px;
  height: 100vh;
  padding-top: 20px;
  border-right: 1px solid var(--Color-Border-border-color-light, #E4E7ED);
}
.desktop-styles .app .left-menu > .item, .ant-notification-desktop .app .left-menu > .item, .modal-desktop .app .left-menu > .item, .device-type-desktop .app .left-menu > .item {
  height: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.desktop-styles .app .left-menu > .item:not(.disabled) > svg:hover > path[stroke]:not([stroke=""]), .ant-notification-desktop .app .left-menu > .item:not(.disabled) > svg:hover > path[stroke]:not([stroke=""]), .modal-desktop .app .left-menu > .item:not(.disabled) > svg:hover > path[stroke]:not([stroke=""]), .device-type-desktop .app .left-menu > .item:not(.disabled) > svg:hover > path[stroke]:not([stroke=""]), .desktop-styles .app .left-menu > .item.selected > svg > path[stroke]:not([stroke=""]), .ant-notification-desktop .app .left-menu > .item.selected > svg > path[stroke]:not([stroke=""]), .modal-desktop .app .left-menu > .item.selected > svg > path[stroke]:not([stroke=""]), .device-type-desktop .app .left-menu > .item.selected > svg > path[stroke]:not([stroke=""]) {
  stroke: #0088FF;
}
.desktop-styles .app .left-menu > .item:not(.disabled) > svg:hover > path[fill]:not([fill=""]), .ant-notification-desktop .app .left-menu > .item:not(.disabled) > svg:hover > path[fill]:not([fill=""]), .modal-desktop .app .left-menu > .item:not(.disabled) > svg:hover > path[fill]:not([fill=""]), .device-type-desktop .app .left-menu > .item:not(.disabled) > svg:hover > path[fill]:not([fill=""]), .desktop-styles .app .left-menu > .item.selected > svg > path[fill]:not([fill=""]), .ant-notification-desktop .app .left-menu > .item.selected > svg > path[fill]:not([fill=""]), .modal-desktop .app .left-menu > .item.selected > svg > path[fill]:not([fill=""]), .device-type-desktop .app .left-menu > .item.selected > svg > path[fill]:not([fill=""]) {
  fill: #0088FF;
}
.desktop-styles .app .left-menu > .item.disabled > svg > path[stroke]:not([stroke=""]), .ant-notification-desktop .app .left-menu > .item.disabled > svg > path[stroke]:not([stroke=""]), .modal-desktop .app .left-menu > .item.disabled > svg > path[stroke]:not([stroke=""]), .device-type-desktop .app .left-menu > .item.disabled > svg > path[stroke]:not([stroke=""]) {
  stroke: #A1A9B5;
}
.desktop-styles .app .left-menu > .item.disabled > svg > path[fill]:not([fill=""]), .ant-notification-desktop .app .left-menu > .item.disabled > svg > path[fill]:not([fill=""]), .modal-desktop .app .left-menu > .item.disabled > svg > path[fill]:not([fill=""]), .device-type-desktop .app .left-menu > .item.disabled > svg > path[fill]:not([fill=""]) {
  fill: #A1A9B5;
}
.desktop-styles .app .left-menu > .item:not(.disabled):not(.selected):hover, .ant-notification-desktop .app .left-menu > .item:not(.disabled):not(.selected):hover, .modal-desktop .app .left-menu > .item:not(.disabled):not(.selected):hover, .device-type-desktop .app .left-menu > .item:not(.disabled):not(.selected):hover {
  cursor: pointer;
}
.desktop-styles .app .tongue, .ant-notification-desktop .app .tongue, .modal-desktop .app .tongue, .device-type-desktop .app .tongue {
  left: 60px;
  margin: 0;
  border-radius: 0;
  height: 100vh;
  max-height: unset !important;
  box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.0784313725);
}
.desktop-styles .app .tongue.show, .ant-notification-desktop .app .tongue.show, .modal-desktop .app .tongue.show, .device-type-desktop .app .tongue.show {
  max-width: 25% !important;
  min-width: 400px !important;
}
.desktop-styles .app .tongue > .swipe-toggle, .ant-notification-desktop .app .tongue > .swipe-toggle, .modal-desktop .app .tongue > .swipe-toggle, .device-type-desktop .app .tongue > .swipe-toggle {
  display: none;
}
.desktop-styles .app .track .start, .ant-notification-desktop .app .track .start, .modal-desktop .app .track .start, .device-type-desktop .app .track .start {
  left: calc(50% - 187px + 30px);
}
.desktop-styles .app .poi > .tongue.show, .ant-notification-desktop .app .poi > .tongue.show, .modal-desktop .app .poi > .tongue.show, .device-type-desktop .app .poi > .tongue.show {
  min-width: 410px !important;
}
.desktop-styles .app .poi .new, .ant-notification-desktop .app .poi .new, .modal-desktop .app .poi .new, .device-type-desktop .app .poi .new {
  left: calc(50% - 187px + 30px);
}
.desktop-styles .poi .main .tongue-wrapper .categories > .category > .icon, .ant-notification-desktop .poi .main .tongue-wrapper .categories > .category > .icon, .modal-desktop .poi .main .tongue-wrapper .categories > .category > .icon, .device-type-desktop .poi .main .tongue-wrapper .categories > .category > .icon {
  width: 70px !important;
  height: 70px !important;
}
.desktop-styles .poi .view .tongue-wrapper .point > .point-data .text, .ant-notification-desktop .poi .view .tongue-wrapper .point > .point-data .text, .modal-desktop .poi .view .tongue-wrapper .point > .point-data .text, .device-type-desktop .poi .view .tongue-wrapper .point > .point-data .text {
  max-height: unset !important;
}
@media screen and (orientation: landscape) {
  .desktop-styles .auth > .form > div, .ant-notification-desktop .auth > .form > div, .modal-desktop .auth > .form > div, .device-type-desktop .auth > .form > div {
    flex-basis: unset;
    max-width: unset;
    overflow: auto;
  }
  .desktop-styles .menu, .ant-notification-desktop .menu, .modal-desktop .menu, .device-type-desktop .menu {
    display: block !important;
  }
  .desktop-styles .track, .ant-notification-desktop .track, .modal-desktop .track, .device-type-desktop .track {
    display: unset !important;
  }
  .desktop-styles .profile, .ant-notification-desktop .profile, .modal-desktop .profile, .device-type-desktop .profile {
    display: unset !important;
  }
  .desktop-styles .poi .view .tongue-wrapper .point > .point-data .text, .ant-notification-desktop .poi .view .tongue-wrapper .point > .point-data .text, .modal-desktop .poi .view .tongue-wrapper .point > .point-data .text, .device-type-desktop .poi .view .tongue-wrapper .point > .point-data .text {
    max-height: 500px;
  }
  .desktop-styles .auth > .auth-img, .ant-notification-desktop .auth > .auth-img, .modal-desktop .auth > .auth-img, .device-type-desktop .auth > .auth-img {
    display: block;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    border-radius: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/default/font.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/default/base.scss","webpack://./src/styles/default/buttons.scss","webpack://./src/styles/default/modal.scss","webpack://./src/styles/default/notify.scss","webpack://./src/styles/default/auth.scss","webpack://./src/styles/default/app.scss","webpack://./src/styles/default/map.scss","webpack://./src/styles/default/menu.scss","webpack://./src/styles/default/service/main.scss","webpack://./src/styles/default/service/adapter.scss","webpack://./src/styles/default/service/track.scss","webpack://./src/styles/default/service/profile.scss","webpack://./src/styles/default/service/poi.scss","webpack://./src/styles/default/service/layer.scss","webpack://./src/styles/default/data.scss","webpack://./src/styles/adaptive/landscape.scss","webpack://./src/styles/adaptive/tablet/portrait.scss","webpack://./src/styles/adaptive/tablet/landscape.scss","webpack://./src/styles/adaptive/desktop/portrait.scss","webpack://./src/styles/adaptive/desktop/landscape.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,4CAAA;AADF;AAIA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;AAFF;AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;AAHF;AAMA;EACE,qBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;AAJF;AAOA;EACE,qBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;AALF;AAQA;EACE,qBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;AANF;AC/BA;EACE,sBCDiB;EDEjB,kCAAA;EACA,8BAAA;ADiCF;;AC5BA;EAEE,cCcmB;EDbnB,eAAA;EACA,gBAAA;EACA,iBAAA;AD8BF;;AC3BA;EAEE,cCMmB;EDLnB,eAAA;EACA,gBAAA;EACA,iBAAA;AD6BF;;AC1BA;EAEE,cCFmB;EDGnB,eAAA;EACA,gBAAA;EACA,iBAAA;AD4BF;;ACzBA;EAEE,cCVmB;EDWnB,eAAA;EACA,gBAAA;EACA,iBAAA;AD2BF;;ACxBA;EAEE,cClBmB;EDmBnB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AD0BF;;ACrBA;EAEE,cC5BqB;ED6BrB,eAAA;EACA,gBAAA;EACA,iBAAA;ADuBF;;ACpBA;EAEE,cCpCqB;EDqCrB,eAAA;EACA,gBAAA;EACA,iBAAA;ADsBF;;ACnBA;EAEE,cC5CqB;ED6CrB,eAAA;EACA,gBAAA;EACA,iBAAA;ADqBF;;AClBA;EAEE,cCpDqB;EDqDrB,eAAA;EACA,gBAAA;EACA,iBAAA;ADoBF;;ACjBA;EAEE,cC5DqB;ED6DrB,eAAA;EACA,gBAAA;EACA,iBAAA;ADmBF;;AChBA;EACE,cCpEmB;AFuFrB;;AG/GA;EACE;IAAM,UAAA;EHmHN;EGlHA;IAAM,YAAA;EHqHN;EGpHA;IAAM,UAAA;EHuHN;AACF;AGrHA;EACE,YAAA;EACA,sBDRiB;ECSjB,cDemB;ECdnB,kCAAA;EACA,8BAAA;AHuHF;AGrHE;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AHuHJ;AGrHI;EACE,YAAA;AHuHN;AGrHM;EACE,YAAA;AHuHR;;AGjHA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AHoHF;AGjHI;EACE,eAAA;AHmHN;;AIzJA;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;AJ2JF;;AIxJA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AJ2JF;AIvJE;EACE,UAAA;AJyJJ;;AIrJA;EACE,yBFaqB;EEZrB,cFa0B;AF2I5B;;AIpJA;EACE,oCAAA;EACA,yBAAA;AJuJF;;AInJA;EAEE,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,SAAA;EACA,iBAAA;AJqJF;AInJE;EACE,yBAAA;AJqJJ;;AIjJA;EACE,8DAAA;EACA,cFpBmB;AFwKrB;;AI9IG;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJiJL;AI/IK;EACE,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;AJiJP;AI/IO;EACE,kBAAA;AJiJT;AI5IE;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;AJ8IJ;AI3IM;EACE,kBAAA;EACA,SAAA;AJ6IR;AIxIE;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;AJ0IJ;AIvIE;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;AJyIJ;AInII;EACE,yBAAA;AJqIN;AIjIE;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;AJmIJ;AIhIE;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;AJkIJ;;AK3PA;EACE,8BAAA;EACA,4BAAA;AL8PF;AK1PI;EACE,mDH4Bc;EG3Bd,WAAA;EACA,YAAA;EACA,mBAAA;AL4PN;AKzPM;EACE,WAAA;EACA,YAAA;AL2PR;AKnPQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;ALqPV;AKnPU;EACE,gBAAA;EACA,mBAAA;ALqPZ;AK/OI;EAEE,cHbe;AF6PrB;AK7OI;EACE,gBAAA;AL+ON;AK7OM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AL+OR;AK7OQ;EACE,aAAA;AL+OV;AK7OU;EACE,WAAA;AL+OZ;AKtOI;EAEE,cHzCe;EG0Cf,sBAAA;ALuON;AKpOI;EAEE,cH7Ce;EG8Cf,cAAA;ALqON;AKhOI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;ALkON;AKhOM;EACE,cAAA;ALkOR;AK/NM;EAEE,cHhEa;EGiEb,kBAAA;EACA,cAAA;ALgOR;AK1NI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,cH3Ee;AFsSrB;AKtNI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;ALwNN;AKtNM;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;ALwNR;AKrNM;EAEE,cHhGa;EGiGb,kBAAA;ALsNR;AKnNM;EAEE,cHpGa;EGqGb,cAAA;EACA,kBAAA;ALoNR;;AMlVE;EACE,yBJYqB;EIXrB,qCAAA;ANqVJ;AMnVI;EAEE,yBAAA;EACA,SAAA;EACA,kBAAA;ANoVN;AMjVI;EACE,qBAAA;EACA,qBAAA;ANmVN;AMjVM;EACE,cJJM;EIKN,WAAA;EACA,YAAA;ANmVR;;AOvWA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sCAAA;AP0WF;AOxWE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AP0WJ;AOxWI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AP0WN;AOxWM;EACE,kBAAA;AP0WR;AOvWM;EACE,eAAA;APyWR;AOvWQ;EACE,kBAAA;APyWV;AOvWU;EACE,cLCW;EKAX,mBAAA;EACA,eAAA;APyWZ;AOpWM;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;APsWR;AOpWQ;EACE,kBAAA;APsWV;AOpWU;EACE,oBAAA;APsWZ;AOjWM;EACE,YAAA;APmWR;AOjWQ;EAEE,cLnCW;EKoCX,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;APkWV;AOhWU;EACE,UAAA;EAEA,cL7CS;AF8YrB;AO9VU;EAEE,cL/Ca;AF8YzB;AO5VU;EACE,gCAAA;AP8VZ;AOzVM;EACE,WAAA;AP2VR;AOxVM;EACE,YAAA;AP0VR;AOvVU;EACE,WAAA;EACA,oBAAA;APyVZ;;AQ/aA;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;ARkbF;AS7bA;EACE,yBAAA;EACA,uBAAA;EACA,eAAA;AT+bF;AS7bE;EACE,iBAAA;EACA,yBAAA;EACA,2BAAA;AT+bJ;AS3bA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,qCAAA;EACA,UAAA;EACA,gBAAA;AT6bF;AS3bE;EACE,+BAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;AT6bJ;AS1bE;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AT4bJ;ASzbE;EACE,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AT2bJ;ASxbE;EACE,WAAA;EACA,WAAA;AT0bJ;ASxbI;EACE,WAAA;EACA,yBAAA;AT0bN;ASxbI;EACE,YAAA;AT0bN;ASxbI;EACE,YAAA;AT0bN;AStbE;EACE,aAAA;EACA,SAAA;EACA,iCAAA;ATwbJ;AStbI;EACE,UAAA;EACA,aAAA;EACA,yBAAA;ATwbN;AStbI;EACE,kCAAA;ATwbN;AStbI;EACE,UAAA;EACA,4BAAA;ATwbN;ASpbE;EACE,uCAAA;EACA,iCAAA;ATsbJ;ASpbI;EACE,aAAA;EACA,uBAAA;ATsbN;ASpbI;EACE,aAAA;EACA,kCAAA;ATsbN;ASpbI;EACE,4BAAA;ATsbN;ASlbE;EACE,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mDAAA;EACA,YAAA;ATobJ;ASlbI;EACE,eAAA;EACA,aAAA;ATobN;AShbE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;ATkbJ;AShbI;EAEE,aAAA;EACA,sBAAA;ATibN;AS/aM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;ATibR;AS9aQ;EAEE,mBAAA;EACA,cAAA;AT+aV;AS5aQ;EAEE,mBAAA;EACA,YAAA;EACA,cAAA;AT6aV;AS3aU;EACE,YAAA;AT6aZ;ASzaQ;EACE,gBAAA;EACA,YAAA;AT2aV;ASzaU;EACE,gBAAA;EACA,cAAA;AT2aZ;AU9kBA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,mDR6BsB;EQ5BtB,mBAAA;EACA,gBAAA;AVglBF;AU9kBE;EACE,aAAA;AVglBJ;AU7kBE;EACE,uBAAA;AV+kBJ;AU5kBE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AV8kBJ;AU5kBI;EACE,aAAA;AV8kBN;AU3kBI;EACE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AV6kBN;AU3kBM;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AV6kBR;AU3kBQ;EACE,yBR1CG;EQ2CH,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AV6kBV;AU3kBW;EACE,0CAAA;EACA,eAAA;AV6kBb;AU1kBU;EACE,YAAA;AV4kBZ;AU1kBY;EACE,kBAAA;EACA,YAAA;AV4kBd;AUzkBY;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AV2kBd;AUvkBU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AVykBZ;AUvkBY;EACE,UAAA;EACA,WAAA;AVykBd;AUpkBQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,yBRjEY;EQkEZ,8BAAA;EACA,+BAAA;AVskBV;AUnkBQ;EACE,yBAAA;AVqkBV;AU9jBE;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AVgkBJ;AU9jBI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AVgkBN;AU9jBM;EACE,yBAAA;AVgkBR;AWnsBA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,OAAA;EACA,yBTewB;ESdxB,4BAAA;EACA,6BAAA;EACA,2BAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;AXosBF;AWlsBE;EACE,yBAAA;AXosBJ;AWlsBE;EACE,YAAA;AXosBJ;AWlsBE;EACE,aAAA;AXosBJ;AWhsBI;EACE,6BAAA;AXksBN;AWhsBI;EACE,4BAAA;AXksBN;AWhsBI;EACE,iBAAA;AXksBN;AW9rBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AXgsBJ;AW9rBI;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,yBTpCa;AFouBnB;AW5rBE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AX8rBJ;AW5rBI;EAEE,gBAAA;EACA,eAAA;AX6rBN;AW3rBM;EACE,SAAA;EACA,iBAAA;EACA,YAAA;AX6rBR;AW1rBM;EACE,YAAA;EACA,kBAAA;AX4rBR;AWlrBA;EACE,kBAAA;AXorBF;AWlrBE;EACE,kBAAA;AXorBJ;AWlrBI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;AXorBN;AWjrBI;EACE,UAAA;EACA,WAAA;EACA,YAAA;AXmrBN;AW9qBA;EACE,aAAA;EACA,sBAAA;AXgrBF;AY1xBI;EACE,iBAAA;AZ4xBN;AYxxBE;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;AZ0xBJ;AYxxBI;EACE,oBAAA;AZ0xBN;AYvxBI;EACE,yBAAA;EACA,cAAA;AZyxBN;AYvxBM;EACE,yBAAA;AZyxBR;Aa3yBI;EACE,iBAAA;Ab6yBN;AazyBQ;EACE,iBAAA;EACA,YAAA;EACA,8DAAA;EACA,YAAA;Ab2yBV;AavyBM;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;AbyyBR;AavyBQ;EACE,aAAA;AbyyBV;AavyBU;EACE,eAAA;EACA,yBXmBW;AFsxBvB;AatyBU;EACE,iBAAA;AbwyBZ;AaryBU;EACE,cAAA;EACA,UAAA;EACA,YAAA;AbuyBZ;AapyBc;EACE,yBAAA;AbsyBhB;AavyBc;EACE,yBAAA;AbyyBhB;Aa1yBc;EACE,yBAAA;Ab4yBhB;Aa7yBc;EACE,yBAAA;Ab+yBhB;AahzBc;EACE,yBAAA;AbkzBhB;AanzBc;EACE,yBAAA;AbqzBhB;AatzBc;EACE,yBAAA;AbwzBhB;AanzBU;EACE,WAAA;AbqzBZ;AajzBQ;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AbmzBV;AajzBU;EACE,iBAAA;AbmzBZ;Aa7yBM;EACE,iBAAA;Ab+yBR;Aa5yBM;EACE,aAAA;EACA,aAAA;EACA,SAAA;Ab8yBR;Aa5yBQ;EACE,kBAAA;Ab8yBV;Aa3yBQ;EACE,aAAA;Ab6yBV;Aa1yBQ;EACE,uBAAA;Ab4yBV;AaxyBM;EACE,kBAAA;Ab0yBR;AaxyBQ;EACE,WAAA;Ab0yBV;AatyBM;EACE,kBAAA;AbwyBR;AaryBM;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AbuyBR;AaryBQ;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AbuyBV;AapyBQ;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AbsyBV;AapyBU;EAEE,wBAAA;AbqyBZ;AazxBM;EACE,aAAA;EACA,kBAAA;Ab2xBR;AazxBQ;EACE,WAAA;Ab2xBV;AazxBU;EACE,cAAA;EACA,UAAA;EACA,YAAA;Ab2xBZ;AaxxBc;EACE,yBAAA;Ab0xBhB;Aa3xBc;EACE,yBAAA;Ab6xBhB;Aa9xBc;EACE,yBAAA;AbgyBhB;AajyBc;EACE,yBAAA;AbmyBhB;AapyBc;EACE,yBAAA;AbsyBhB;AavyBc;EACE,yBAAA;AbyyBhB;Aa1yBc;EACE,yBAAA;Ab4yBhB;AatyBQ;EACE,YAAA;AbwyBV;AatyBU;EACE,kBAAA;AbwyBZ;AanyBM;EACE,yBAAA;AbqyBR;AanyBQ;EACE,YAAA;EACA,SAAA;EACA,UAAA;AbqyBV;Aa/xBE;EACE,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,yBX/JsB;EWgKtB,mBAAA;EACA,aAAA;EACA,sBAAA;AbiyBJ;Aa3xBI;EACE,uBAAA;Ab6xBN;Aa3xBM;EACE,yBX5KkB;EW6KlB,YAAA;EACA,uBAAA;Ab6xBR;AarxBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AbuxBN;AarxBM;EACE,yBAAA;EACA,cAAA;EACA,+CAAA;AbuxBR;AapxBM;EACE,gBAAA;AbsxBR;AalxBI;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,QAAA;AboxBN;AalxBM;EACE,YAAA;AboxBR;AalxBQ;EACE,yBXzNI;AF6+Bd;AajxBQ;EACE,yBXrNgB;EWsNhB,YAAA;AbmxBV;Aa9wBI;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AbgxBN;Aa9wBM;EACE,YAAA;AbgxBR;Aa9wBQ;EACE,kBAAA;AbgxBV;Aa1wBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,yBXxPsB;AFogC1B;Aa1wBI;EACE,YAAA;Ab4wBN;Aa1wBM;EACE,iBAAA;Ab4wBR;Aa1wBQ;EACE,SAAA;EACA,YAAA;Ab4wBV;AazwBQ;EACE,YAAA;Ab2wBV;AarwBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AbuwBN;AarwBM;EACE,eAAA;EACA,mBAAA;AbuwBR;AapwBM;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AbswBR;AanwBM;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AbqwBR;AanwBQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AbqwBV;AanwBU;EACE,qBX9RW;AFmiCvB;AalwBU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AbowBZ;AajwBc;EACE,yBAAA;AbmwBhB;AapwBc;EACE,yBAAA;AbswBhB;AavwBc;EACE,yBAAA;AbywBhB;Aa1wBc;EACE,yBAAA;Ab4wBhB;Aa7wBc;EACE,yBAAA;Ab+wBhB;AahxBc;EACE,yBAAA;AbkxBhB;AanxBc;EACE,yBAAA;AbqxBhB;Aa9wBM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AbgxBR;Aa9wBQ;EACE,YAAA;AbgxBV;Aa7wBQ;EACE,gBAAA;EACA,cX/UI;EWgVJ,UAAA;EACA,SAAA;Ab+wBV;Aa5wBQ;EACE,WAAA;Ab8wBV;Ac/mCI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,6BAAA;EACA,uBAAA;EAEA,aAAA;EACA,sBAAA;EACA,WAAA;AdgnCN;Ac9mCM;EACE,2BAAA;EAEA,cZSa;AFsmCrB;Ac5mCM;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;Ad8mCR;Ac5mCQ;EACE,eAAA;EACA,yBZgBa;AF8lCvB;Ac3mCQ;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;Ad6mCV;Ac1mCQ;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;Ad4mCV;ActmCU;EACE,yBAAA;AdwmCZ;AcpmCQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AdsmCV;AcnmCQ;EACE,6BAAA;AdqmCV;AclmCQ;EACE,gBAAA;AdomCV;AclmCU;EACE,QAAA;AdomCZ;AchmCQ;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;AdkmCV;AchmCU;EACE,yBZlDW;AFopCvB;Ac9lCQ;EACE,eAAA;AdgmCV;Ac9lCU;EACE,UAAA;EACA,4BAAA;EACA,QAAA;AdgmCZ;Ac9lCY;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AdgmCd;Ac9lCc;EACE,eAAA;AdgmChB;Ac5lCY;EAEE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;Ad6lCd;Ac3lCc;EACE,yBAAA;Ad6lChB;Ac1lCc;EACE,mBAAA;EACA,kBAAA;Ad4lChB;AcnlCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,yBZhHsB;EYkHtB,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,6BAAA;EACA,uBAAA;AdmlCJ;AcjlCI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EAEA,cZ/He;AFitCrB;AchlCM;EACE,YAAA;AdklCR;Ac1kCI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;Ad4kCN;Ac1kCM;EACE,SAAA;Ad4kCR;AcvkCQ;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AdykCV;AcvkCU;EACE,mBAAA;EACA,iBAAA;AdykCZ;AcvkCY;EAEE,YAAA;EACA,cZ/JO;AFuuCrB;AcpkCU;EACE,YAAA;AdskCZ;AcnkCU;EACE,YAAA;EACA,WAAA;AdqkCZ;AclkCU;EAEE,cZ9KS;AFivCrB;AchkCU;EAEE,cZlLa;AFmvCzB;Ac5jCM;EACE,YAAA;EACA,uBAAA;EACA,mBAAA;Ad8jCR;AczjCM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;Ad2jCR;AcxjCQ;EACE,YAAA;EACA,iBAAA;EACA,cZlMa;AF4vCvB;AcvjCQ;EACE,yBZtMa;AF+vCvB;AcvjCU;EAEE,yBAAA;AdwjCZ;AcpjCQ;EACE,yBZjMoB;AFuvC9B;AcpjCU;EACE,yBAAA;AdsjCZ;Ac9iCM;EACE,kBAAA;AdgjCR;Ac9iCQ;EACE,kBAAA;AdgjCV;Ac7iCQ;EACE,iBAAA;EACA,YAAA;Ad+iCV;Ac1iCU;EACE,cZxOgB;EYyOhB,yBZ1OW;EY2OX,qBZ3OW;AFuxCvB;AcviCU;EACE,cZrPM;EYsPN,yBZrOW;EYsOX,qBZrOkB;AF8wC9B;AcpiCU;EACE,yBZ/OW;EYgPX,qBZ/OkB;AFqxC9B;AcpiCY;EACE,cZ7PS;AFmyCvB;AcliCU;EACE,yBZlQW;AFsyCvB;AchiCQ;EACE,SAAA;AdkiCV;Ac5hCQ;EACE,yBAAA;Ad8hCV;AcxhCU;EACE,gBAAA;EAEA,cZ/RW;AFwzCvB;AchhCc;EACE,YAAA;AdkhChB;Ac5gCgB;EACE,aAAA;EACA,mBAAA;Ad8gClB;Ac5gCkB;EACE,YAAA;Ad8gCpB;Ac5gCoB;EACE,WAAA;Ad8gCtB;Ac1gCkB;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;Ad4gCpB;Ac1gCoB;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EAEA,yBAAA;EACA,cZlUF;AF60CpB;AczgCsB;EACE,8BAAA;EACA,2BAAA;Ad2gCxB;AcxgCsB;EACE,+BAAA;EACA,4BAAA;Ad0gCxB;AcvgCsB;EACE,yBZ5UD;EY6UC,cZ5UI;EY6UJ,qBZ9UD;AFu1CvB;AcngCgB;EACE,kBAAA;EACA,eAAA;EAEA,cZxVK;EYyVL,eAAA;AdogClB;Ac//BY;EACE,cAAA;EACA,WAAA;AdigCd;Ac5/BQ;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;Ad8/BV;Ac5/BU;EACE,WAAA;Ad8/BZ;Acr/BM;EACE,gBAAA;Adu/BR;Aez4CI;EACE,gBAAA;Af24CN;Aet4CM;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;Afw4CR;Aet4CQ;EACE,YAAA;Afw4CV;Aet4CU;EACE,iBAAA;EACA,YAAA;EACA,8DAAA;EACA,YAAA;Afw4CZ;Aen4CM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;Afq4CR;Aen4CQ;EACE,eAAA;Afq4CV;Aen4CU;EACE,eAAA;Afq4CZ;Ael4CU;EACE,YAAA;Afo4CZ;Aej4CU;EACE,UAAA;Afm4CZ;Aeh4CU;EACE,UAAA;Afk4CZ;Ae/3CU;EACE,qBAAA;Afi4CZ;Ae33Cc;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;Af63ChB;Ae33CgB;EACE,aAAA;EACA,mBAAA;Af63ClB;Ae33CkB;EACE,SAAA;Af63CpB;Ae33CoB;EACE,kBAAA;Af63CtB;Ae13CoB;EACE,aAAA;Af43CtB;Aez3CoB;EACE,uBAAA;Af23CtB;Aev3CkB;EACE,WAAA;Afy3CpB;Aet3CkB;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAIA,YAAA;EACA,iBAAA;Afq3CpB;Ae32Cc;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;Af62ChB;Ae32CgB;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;Af62ClB;Ae12CgB;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;Af42ClB;Ae12CkB;EAEE,wBAAA;Af22CpB;Aer2Cc;EACE,YAAA;EACA,cAAA;EACA,YAAA;Afu2ChB;Aer2CgB;EACE,aAAA;Afu2ClB;Aer2CkB;EACE,yBbrGG;EasGH,eAAA;Afu2CpB;Aep2CkB;EACE,kBAAA;Afs2CpB;Aep2CoB;EACE,cAAA;Afs2CtB;Aen2CwB;EACE,yBAAA;Afq2C1B;Aet2CwB;EACE,yBAAA;Afw2C1B;Aez2CwB;EACE,yBAAA;Af22C1B;Ae52CwB;EACE,yBAAA;Af82C1B;Ae/2CwB;EACE,yBAAA;Afi3C1B;Ael3CwB;EACE,yBAAA;Afo3C1B;Aer3CwB;EACE,yBAAA;Afu3C1B;Aeh3CgB;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;Afk3ClB;Aeh3CkB;EACE,iBAAA;Afk3CpB;Ae72CgB;EACE,WAAA;Af+2ClB;Aez2CU;EACE,6BAAA;Af22CZ;Aez2CY;EACE,eAAA;EACA,yBbjJS;AF4/CvB;Aex2CY;EAEE,eAAA;Afy2Cd;Aep2CgB;EACE,gBAAA;Afs2ClB;Ael2CgB;EACE,cbtLK;AF0hDvB;Aen2CkB;EACE,YAAA;Afq2CpB;Aeh2CkB;EACE,YAAA;EACA,iBAAA;Afk2CpB;Aeh2CoB;EACE,WAAA;EACA,YAAA;Afk2CtB;Aez1Cc;EACE,uBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;Af21ChB;Aez1CgB;EACE,YAAA;Af21ClB;Aez1CgB;EACE,WAAA;Af21ClB;Aex1CgB;EACE,yBbvMK;EawML,eAAA;Af01ClB;Aev1CgB;EACE,yBb/MK;AFwiDvB;Aet1CgB;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;Afw1ClB;Aet1CkB;EACE,yBAAA;Afw1CpB;Aep1CgB;EAEE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;Afq1ClB;Ae30CE;EACE,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,yBbxQsB;EayQtB,mBAAA;EACA,aAAA;EACA,sBAAA;Af60CJ;Aev0CI;EACE,uBAAA;Afy0CN;Aev0CM;EACE,yBbrRkB;EasRlB,YAAA;EACA,uBAAA;Afy0CR;Aep0CE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,yBbrSsB;AF2mD1B;Aep0CI;EACE,YAAA;Afs0CN;Aep0CM;EACE,iBAAA;Afs0CR;Aep0CQ;EACE,SAAA;EACA,YAAA;Afs0CV;Aen0CQ;EACE,YAAA;Afq0CV;Ae/zCI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;Afi0CN;Ae/zCM;EACE,eAAA;EACA,mBAAA;Afi0CR;Ae9zCM;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;Afg0CR;Ae7zCM;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;Af+zCR;Ae7zCQ;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;Af+zCV;Ae7zCU;EACE,qBb1UW;AFyoDvB;Ae1zCc;EACE,yBAAA;Af4zChB;Ae7zCc;EACE,yBAAA;Af+zChB;Aeh0Cc;EACE,yBAAA;Afk0ChB;Aen0Cc;EACE,yBAAA;Afq0ChB;Aet0Cc;EACE,yBAAA;Afw0ChB;Aez0Cc;EACE,yBAAA;Af20ChB;Ae50Cc;EACE,yBAAA;Af80ChB;Aev0CM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;Afy0CR;Aev0CQ;EACE,YAAA;Afy0CV;Aet0CQ;EACE,gBAAA;EACA,cbtXI;EauXJ,UAAA;EACA,SAAA;Afw0CV;Aer0CQ;EACE,WAAA;Afu0CV;Ae7zCM;EACE,aAAA;EACA,2BAAA;EACA,YAAA;Af+zCR;Ae7zCQ;EACE,YAAA;Af+zCV;Ae7zCU;EAEE,mBAAA;EACA,aAAA;EACA,mBAAA;Af8zCZ;Ae5zCY;EACE,eAAA;EACA,kBAAA;Af8zCd;Ae3zCgB;EACE,yBAAA;Af6zClB;Ae9zCgB;EACE,yBAAA;Afg0ClB;Aej0CgB;EACE,yBAAA;Afm0ClB;Aep0CgB;EACE,yBAAA;Afs0ClB;Aev0CgB;EACE,yBAAA;Afy0ClB;Ae10CgB;EACE,yBAAA;Af40ClB;Ae70CgB;EACE,yBAAA;Af+0ClB;Aez0CU;EAEE,iBAAA;EACA,gBAAA;Af00CZ;Aex0CY;EACE,aAAA;Af00Cd;Aer0CqB;EACC,gCAAA;Afu0CtB;Aej0Cc;EACE,yBbxZE;EayZF,kBAAA;Afm0ChB;Aeh0Cc;EACE,cAAA;Afk0ChB;Aeh0CgB;EACE,mBAAA;EACA,cblbG;AFovDrB;Aeh0CkB;EACE,YAAA;Afk0CpB;Ae5zCkB;EACE,cbrbF;EasbE,qBAAA;Af8zCpB;Ae3zCkB;EACE,cAAA;EACA,SAAA;EACA,cAAA;Af6zCpB;AepzCM;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AfszCR;AenzCQ;EACE,YAAA;EACA,SAAA;EACA,UAAA;AfqzCV;AenzCU;EAEE,cb1dS;AF8wDrB;AelzCY;EACE,WAAA;EACA,YAAA;AfozCd;AejzCU;EACE,cb5eE;AF+xDd;Ae3yCA;EACE,kBAAA;EACA,iCAAA;EACA,gCAAA;EACA,2CAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;Af6yCF;AgBrzDI;EACE,gBAAA;AhBuzDN;AgBlzDM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AhBozDR;AgBlzDQ;EACE,eAAA;EACA,aAAA;AhBozDV;AgBlzDU;EACE,kBAAA;AhBozDZ;AgBlzDY;EACE,yBAAA;EACA,kBAAA;AhBozDd;AgBlzDc;EACE,yBAAA;AhBozDhB;AgB9yDQ;EACE,WAAA;AhBgzDV;AiBj1DA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AjBm1DF;AiBj1DE;EACE,yBfasB;EeZtB,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AjBm1DJ;AiBj1DI;EACE,gBAAA;AjBm1DN;AiBh1DI;EACE,gBAAA;EACA,kBAAA;AjBk1DN;AiB50DE;EACE,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;AjB60DJ;AiB30DI;EACE,gBAAA;EACA,kBAAA;AjB60DN;;AAr0DA;EkB/CA;IACE,WAAA;IACA,eAAA;IACA,uBAAA;IACA,cAAA;ElBw3DA;EkBt3DA;IACE,cAAA;ElBw3DF;EkBt3DE;IACE,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;ElBw3DJ;EkBt3DI;IACE,YAAA;IACA,aAAA;ElBw3DN;EkBp3DE;IACE,gBAAA;IACA,cAAA;IACA,0BAAA;IACA,6BAAA;ElBs3DJ;EkBp3DI;IACE,cAAA;ElBs3DN;EkBn3DI;IACE,WAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;ElBq3DN;EkBn3DM;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;ElBq3DR;EkBn3DQ;IACE,YAAA;IACA,aAAA;ElBq3DV;EkB/2DE;IACE,eAAA;ElBi3DJ;EkB32DF;IACE,wBAAA;ElB62DA;EkB12DF;IACE,wBAAA;ElB42DA;EkBz2DF;IACE,wBAAA;ElB22DA;AACF;AmBn7DA;EACE,YAAA;EACA,aAAA;AnBq7DF;AmBn7DE;EACE,aAAA;AnBq7DJ;AmB36DI;EACE,2BAAA;EACA,SAAA;AnB66DN;AmBx6DI;EACE,eAAA;EACA,kBAAA;AnB06DN;AmBr6DA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;AnBu6DF;AmBn6DM;EACE,YAAA;EACA,aAAA;AnBq6DR;AmBj6DI;EACE,YAAA;AnBm6DN;AmBj6DM;EACE,YAAA;EACA,mBAAA;AnBm6DR;AmBj6DQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AnBm6DV;AmBj6DU;EACE,YAAA;EACA,aAAA;AnBm6DZ;AmB35DA;EACE,YAAA;EACA,YAAA;AnB65DF;AmB35DE;EACE,aAAA;AnB65DJ;AmB15DE;EACE,SAAA;EACA,YAAA;EACA,sBAAA;AnB45DJ;AmB15DI;EACE,sBAAA;EACA,uBAAA;AnB45DN;AmBv5DA;EACE,2BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,MAAA;EACA,0CAAA;EAEA,wBAAA;AnBw5DF;AmBt5DE;EACE,yBAAA;AnBw5DJ;AmBt5DE;EACE,uBAAA;AnBw5DJ;AmBr5DE;EACE,yBAAA;EACA,gBAAA;AnBu5DJ;AmBr5DI;EACE,6BAAA;AnBu5DN;AmBr5DI;EACE,uBAAA;AnBu5DN;AmBn5DE;EACE,YAAA;EACA,QAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AnBq5DJ;AmBn5DI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AnBq5DN;AmBj5DE;EACE,gBAAA;AnBm5DJ;AmBj5DI;EACE,gBAAA;AnBm5DN;AmB54DE;EACE,YAAA;EACA,uBAAA;AnB84DJ;AmB34DE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,mBAAA;AnB64DJ;AmB34DI;EACE,YAAA;AnB64DN;AmB14DI;EACE,yBAAA;EACA,wBAAA;EACA,yBAAA;AnB44DN;AmB14DM;EACE,oBAAA;AnB44DR;AmBz4DM;EACE,mBAAA;EACA,qBAAA;AnB24DR;AmBz4DQ;EACE,iBAAA;AnB24DV;AmBz4DQ;EACE,YAAA;AnB24DV;AmBn4DE;EACE,YAAA;EACA,uBAAA;AnBq4DJ;AmBl4DE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,mBAAA;AnBo4DJ;AmBl4DI;EACE,YAAA;AnBo4DN;AmBj4DI;EACE,yBAAA;EACA,wBAAA;EACA,yBAAA;AnBm4DN;AmBj4DM;EACE,oBAAA;AnBm4DR;AmBh4DM;EACE,mBAAA;EACA,qBAAA;AnBk4DR;AmBh4DQ;EACE,iBAAA;AnBk4DV;AmBh4DQ;EACE,YAAA;AnBk4DV;AmBz3DQ;EACE,iBAAA;AnB23DV;AmBn3DE;EACI,2BAAA;AnBq3DN;AmB92DI;EACE,2BAAA;AnBg3DN;AmB32DQ;EACE,yBAAA;AnB62DV;AmB12DQ;EACE,gBAAA;AnB42DV;AmB12DU;EACE,eAAA;AnB42DZ;AmBp2DM;EACE,aAAA;EACA,mBAAA;AnBs2DR;AmBp2DQ;EACE,YAAA;EACA,iBAAA;AnBs2DV;AmBj2DI;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AnBm2DN;AmBh2DQ;EACE,iBAAA;AnBk2DV;AA5kEI;EoBrDF;IACE,iBAAA;IACA,gBAAA;IACA,cAAA;EpBooEF;EoBhoEF;IACE,yBAAA;EpBkoEA;EoB/nEF;IACE,yBAAA;EpBioEA;EoB9nEF;IACE,yBAAA;EpBgoEA;EoBznEM;IACE,iBAAA;EpB2nER;AACF;;AmBrpEA;EACE,YAAA;EACA,aAAA;AnBwpEF;AmBtpEE;EACE,aAAA;AnBwpEJ;AmB9oEI;EACE,2BAAA;EACA,SAAA;AnBgpEN;AmB3oEI;EACE,eAAA;EACA,kBAAA;AnB6oEN;AmBxoEA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;AnB0oEF;AmBtoEM;EACE,YAAA;EACA,aAAA;AnBwoER;AmBpoEI;EACE,YAAA;AnBsoEN;AmBpoEM;EACE,YAAA;EACA,mBAAA;AnBsoER;AmBpoEQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AnBsoEV;AmBpoEU;EACE,YAAA;EACA,aAAA;AnBsoEZ;AmB9nEA;EACE,YAAA;EACA,YAAA;AnBgoEF;AmB9nEE;EACE,aAAA;AnBgoEJ;AmB7nEE;EACE,SAAA;EACA,YAAA;EACA,sBAAA;AnB+nEJ;AmB7nEI;EACE,sBAAA;EACA,uBAAA;AnB+nEN;AmB1nEA;EACE,2BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,MAAA;EACA,0CAAA;EAEA,wBAAA;AnB2nEF;AmBznEE;EACE,yBAAA;AnB2nEJ;AmBznEE;EACE,uBAAA;AnB2nEJ;AmBxnEE;EACE,yBAAA;EACA,gBAAA;AnB0nEJ;AmBxnEI;EACE,6BAAA;AnB0nEN;AmBxnEI;EACE,uBAAA;AnB0nEN;AmBtnEE;EACE,YAAA;EACA,QAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AnBwnEJ;AmBtnEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AnBwnEN;AmBpnEE;EACE,gBAAA;AnBsnEJ;AmBpnEI;EACE,gBAAA;AnBsnEN;AmB/mEE;EACE,YAAA;EACA,uBAAA;AnBinEJ;AmB9mEE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,mBAAA;AnBgnEJ;AmB9mEI;EACE,YAAA;AnBgnEN;AmB7mEI;EACE,yBAAA;EACA,wBAAA;EACA,yBAAA;AnB+mEN;AmB7mEM;EACE,oBAAA;AnB+mER;AmB5mEM;EACE,mBAAA;EACA,qBAAA;AnB8mER;AmB5mEQ;EACE,iBAAA;AnB8mEV;AmB5mEQ;EACE,YAAA;AnB8mEV;AmBtmEE;EACE,YAAA;EACA,uBAAA;AnBwmEJ;AmBrmEE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,mBAAA;AnBumEJ;AmBrmEI;EACE,YAAA;AnBumEN;AmBpmEI;EACE,yBAAA;EACA,wBAAA;EACA,yBAAA;AnBsmEN;AmBpmEM;EACE,oBAAA;AnBsmER;AmBnmEM;EACE,mBAAA;EACA,qBAAA;AnBqmER;AmBnmEQ;EACE,iBAAA;AnBqmEV;AmBnmEQ;EACE,YAAA;AnBqmEV;AmB5lEQ;EACE,iBAAA;AnB8lEV;AmBtlEE;EACI,2BAAA;AnBwlEN;AmBjlEI;EACE,2BAAA;AnBmlEN;AmB9kEQ;EACE,yBAAA;AnBglEV;AmB7kEQ;EACE,gBAAA;AnB+kEV;AmB7kEU;EACE,eAAA;AnB+kEZ;AmBvkEM;EACE,aAAA;EACA,mBAAA;AnBykER;AmBvkEQ;EACE,YAAA;EACA,iBAAA;AnBykEV;AmBpkEI;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AnBskEN;AmBnkEQ;EACE,iBAAA;AnBqkEV;AqBn2EA;EACE,mBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;ArBq2EF;AqBn2EE;EACE,OAAA;ArBq2EJ;AqBl2EE;EACE,YAAA;EACA,mBAAA;ArBo2EJ;AqBl2EI;EACE,2BAAA;ArBo2EN;AqBh2EE;EACE,aAAA;ArBk2EJ;AqB91EA;EACE,8BAAA;ArBg2EF;AqB91EE;EACE,YAAA;ArBg2EJ;AqB71EE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,uEAAA;ArB+1EJ;AqB71EI;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ArB+1EN;AqB31EU;EACE,eAUqB;ArBm1EjC;AqB11EU;EACE,aAMqB;ArBs1EjC;AqBj2EU;EACE,eAcqB;ArBq1EjC;AqBh2EU;EACE,aAUqB;ArBw1EjC;AqBr1EM;EACE,eAAA;ArBu1ER;AqBl1EE;EACE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,qDAAA;ArBo1EJ;AqBl1EI;EACE,yBAAA;EACA,2BAAA;ArBo1EN;AqBj1EI;EACE,aAAA;ArBm1EN;AqB90EI;EACE,8BAAA;ArBg1EN;AqB30EI;EACE,2BAAA;ArB60EN;AqB10EI;EACE,8BAAA;ArB40EN;AqBn0EM;EACE,sBAAA;EACA,uBAAA;ArBq0ER;AqB7zEQ;EACE,4BAAA;ArB+zEV;AA53EE;EoB7DA;IACE,iBAAA;IACA,gBAAA;IACA,cAAA;EpB47EF;EoBx7EF;IACE,yBAAA;EpB07EA;EoBv7EF;IACE,yBAAA;EpBy7EA;EoBt7EF;IACE,yBAAA;EpBw7EA;EoBj7EM;IACE,iBAAA;EpBm7ER;EsBz8EA;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,sBAAA;IACA,2BAAA;IACA,4BAAA;IACA,yDAAA;IACA,mBAAA;EtB28EF;AACF","sourcesContent":["@charset \"UTF-8\";\n\n@font-face {\n  font-family: \"Candara\";\n  src: url(\"/fonts/Candara.ttf\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"/fonts/OpenSans-VariableFont_wdth,wght.ttf\");\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf\");\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"/fonts/Roboto-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"/fonts/Roboto-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"/fonts/Roboto-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@import \"variables\";\n\n$device-type-prefixes: \"device-type\", \"modal\", \"ant-notification\";\n$device-type-class-name-prefix: \"device-type\";\n// по умолчанию стили для orientation:portrait и device-type:mobile\n@import \"default/app\";\n\n@media screen and (orientation:landscape) {\n  @import \"adaptive/landscape\";\n}\n\n.tablet-styles {\n  @import \"adaptive/tablet/portrait\";\n\n    @media screen and (orientation:landscape) {\n      @import \"adaptive/tablet/landscape\";\n    }\n}\n\n.desktop-styles {\n  @import \"adaptive/desktop/portrait\";\n\n  @media screen and (orientation:landscape) {\n    @import \"adaptive/desktop/landscape\";\n  }\n}\n\n@each $prefix in $device-type-prefixes {\n  .#{$prefix}-tablet {\n    @extend .tablet-styles\n  }\n\n  .#{$prefix}-desktop {\n    @extend .desktop-styles\n  }\n}\n",".nautilus-font {\n  font-family: $base-font-family;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n// header\n\n.large-header-text {\n  @extend .nautilus-font;\n  color: $text-color-primary;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 31px;\n}\n\n.primary-header-text {\n  @extend .nautilus-font;\n  color: $text-color-primary;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 28px;\n}\n\n.regular-header-text {\n  @extend .nautilus-font;\n  color: $text-color-primary;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 26px;\n}\n\n.secondary-header-text {\n  @extend .nautilus-font;\n  color: $text-color-primary;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 22px;\n}\n\n.list-header-text {\n  @extend .nautilus-font;\n  color: $text-color-primary;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: left;\n}\n\n// text\n\n.large-primary-text {\n  @extend .nautilus-font;\n  color: $text-color-secondary;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.primary-text {\n  @extend .nautilus-font;\n  color: $text-color-secondary;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.regular-text {\n  @extend .nautilus-font;\n  color: $text-color-secondary;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.small-text {\n  @extend .nautilus-font;\n  color: $text-color-secondary;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.list-text {\n  @extend .nautilus-font;\n  color: $text-color-secondary;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.dark-text {\n  color: $text-color-primary\n}\n","$base-font-family: Open Sans;\n\n$color-list: (\n  0: #124A74,\n  1: #000000,\n  2: #31CF13,\n  3: #8926B3,\n  4: #FF9812,\n  5: #E01A4F,\n  6: #001AFF\n);\n\n$color-fill: #F0F2F5;\n$color-info-light: #C7C9CC;\n$color-error: #F13B3B;\n$background-color-error: #FFDCDC;\n$color-success: #2fb62b;\n$background-color-success: #e2ffdc;\n\n$border-color: #DCDFE6;\n$border-color-white: #FFFFFF;\n\n$dialog-background-color: #FFFFFF;\n\n$text-color-primary: #17253C;\n$text-color-secondary: #7E8591;\n$text-color-regular: #374151;\n$text-color-placeholder: #A1A9B5;\n$text-color-white: #FFFFFF;\n$text-color-gray: #909399;\n$text-color-gray-2: #606266;\n$text-link-color: #124A74;\n\n$button-color-primary: #0960A3;\n$button-text-color-primary: #FFFFFF;\n$button-color-gray: #919EAB1F;\n$button-color-white: #FFFFFF;\n\n$menu-background-color: #6464644F;\n$menu-selected-color: #26343F;\n\n$background-blue: #F5F7FA;\n\n$background-lightblue: #DCEBF6;\n$background-border-lightblue: #C1D8EA;\n\n$background-lightgray: #F4F4F5;\n$background-border-lightgray: #E9E9EB;\n","@keyframes fadein {\n  0%   {opacity: 0;}\n  50%  {opacity: 0.9;}\n  100% {opacity: 1;}\n}\n\nhtml {\n  height: 100%;\n  font-family: $base-font-family;\n  color: $text-color-primary;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n\n  body {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    overflow: hidden;\n\n    > div#root {\n      height: 100%;\n\n      > div {\n        height: 100%;\n      }\n    }\n  }\n}\n\n.loader {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n\n  > div:nth-child(2) {\n    path {\n      fill-opacity: 0;\n    }\n  }\n}\n",".button-text {\n  @extend .nautilus-font;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 22px;\n}\n\n.button {\n  height: 48px;\n  border-radius: 12px;\n  padding: 14px 16px;\n\n  @extend .button-text;\n\n  &:has(.loader) {\n    padding: 0;\n  }\n}\n\n.button-primary {\n  background-color: $button-color-primary;\n  color: $button-text-color-primary;\n  @extend .button;\n}\n\n.button-regular {\n  background-color: $button-color-white !important;\n  color: $text-color-regular !important;\n  @extend .button;\n}\n\n.button-window-action {\n  @extend .button-regular;\n  height: 24px !important;\n  width: 24px !important;\n  min-width: 24px !important;\n  border: 0;\n  box-shadow: unset;\n\n  >span {\n    color: $text-color-placeholder !important;\n  }\n}\n\n.button-regular-gray {\n  background-color: $button-color-gray !important;\n  color: $text-color-regular;\n  @extend .button;\n}\n\n.float-buttons {\n\n   button {\n     width: 48px;\n     height: 48px;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n\n     div {\n       width: 48px !important;\n       height: 48px !important;\n       display: flex;\n       justify-content: center;\n       align-items: center;\n       padding: 0 !important;\n       margin: 0 !important;\n\n       &.ant-float-btn-body {\n         border-radius: 8px;\n       }\n     }\n   }\n\n  .zoom {\n    position: absolute;\n    z-index: 10;\n    bottom: calc(50% - 32px);\n    right: 20px;\n\n    > button:first-child {\n      > div {\n        position: relative;\n        top: -1px;\n      }\n    }\n  }\n\n  .aim {\n    position: absolute;\n    z-index: 10;\n    bottom: calc(50% - 88px);\n    right: 12px\n  }\n\n  .compas {\n    position: absolute;\n    z-index: 10;\n    bottom: calc(50% - 144px);\n    right: 12px\n  }\n\n   .to-north {\n    @extend .compas;\n\n    svg {\n      transform: rotate(-90deg);\n    }\n  }\n\n  .poi {\n    position: absolute;\n    z-index: 10;\n    bottom: calc(50% - 202px);\n    right: 12px;\n  }\n\n  .osm {\n    position: absolute;\n    z-index: 10;\n    bottom: calc(50% - 260px);\n    right: 12px;\n  }\n}\n",".modal {\n  width: min(460px, calc(100% - 32px));\n  margin: 16px auto !important;\n\n  .ant-modal-content {\n\n    .ant-modal-close {\n      background-color: $button-color-gray;\n      width: 24px;\n      height: 24px;\n      border-radius: 16px;\n\n\n      svg {\n        width: 12px;\n        height: 12px;\n      }\n    }\n\n    .ant-modal-header {\n      .ant-modal-title {\n        @extend .regular-header-text;\n\n        .centered {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          text-align: center;\n\n          > img {\n            margin-top: 10px;\n            margin-bottom: 20px;\n          }\n        }\n      }\n    }\n\n    .ant-modal-body {\n      @extend .large-primary-text;\n      color: $text-color-regular;\n    }\n\n    .ant-modal-footer {\n      margin-top: 20px;\n\n      > .buttons {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n\n        > button {\n          margin: 8px 0;\n\n          &:only-child {\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  &.profile-confirm-modal-modal {\n\n    .ant-modal-title {\n      @extend .regular-header-text;\n      color: $text-color-primary;\n      margin: 8px 26px 8px 0;\n    }\n\n    .ant-modal-body {\n      @extend .large-primary-text;\n      color: $text-color-regular;\n      margin: 10px 0;\n    }\n  }\n\n  &.profile-success-modal {\n    .ant-modal-body {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      > img {\n        margin: 10px 0;\n      }\n\n      > .title {\n        @extend .regular-header-text;\n        color: $text-color-primary;\n        text-align: center;\n        margin: 10px 0;\n      }\n    }\n  }\n\n  &.profile-hint-modal {\n    .hint > .hint-text > div {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      @extend .primary-text;\n      color: $text-color-regular;\n    }\n  }\n\n  &.profile-error-modal {\n    .ant-modal-body {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      > .error-icon {\n        width: 100px;\n        height: 100px;\n        background-color: red;\n        margin-bottom: 20px;\n      }\n\n      > .title {\n        @extend .regular-header-text;\n        color: $text-color-primary;\n        text-align: center;\n      }\n\n      > .text {\n        @extend .primary-text;\n        color: $text-color-regular;\n        margin: 10px 0;\n        text-align: center;\n      }\n    }\n  }\n\n}\n",".ant-notification {\n\n  .error-notification {\n    background-color: $background-color-error;\n    padding: 8px 12px 8px 16px !important;\n\n    .ant-notification-notice-message {\n      @extend .regular-text;\n      color: $color-error !important;\n      margin: 0;\n      text-align: center;\n    }\n\n    .ant-notification-notice-close {\n      inset-inline-end: 8px;\n      top: calc(50% - 11px);\n\n      svg {\n        color: $color-error;\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n}\n",".auth {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(16.100000381469727px);\n\n  .form {\n    display: flex;\n    flex-direction: column;\n    width: 350px;\n    max-width: 92%;\n    height: 100%;\n    padding-top: 12px;\n\n    > div {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      &.logo {\n        align-self: center;\n      }\n\n      &.footer {\n        padding: 24px 0;\n\n        > span {\n          text-align: center;\n\n          > a {\n            color: $button-color-primary;\n            padding-left: 0.3em;\n            cursor: pointer;\n          }\n        }\n      }\n\n      > .welcome-text {\n        padding: 20px 7px 32px 7px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        >div {\n          text-align: center;\n\n          &:first-child {\n            padding-bottom: 12px;\n          }\n        }\n      }\n\n      > .data {\n        flex-grow: 1;\n\n        .input {\n          @extend .primary-text;\n          color: $text-color-primary;\n          padding: 14px 16px;\n          border: 1px solid $border-color;\n          border-radius: 8px;\n          width: 100%;\n          margin-bottom: 16px;\n\n          input {\n            padding: 0;\n            @extend .primary-text;\n            color: $text-color-primary;\n          }\n\n          &::placeholder {\n            @extend .primary-text;\n            color: $text-color-placeholder;\n          }\n\n          &.ant-input-status-error {\n            border-color: $color-error !important;\n          }\n        }\n      }\n\n      > button {\n        width: 100%;\n      }\n\n      &.login {\n        flex-grow: 1;\n\n        > .data {\n          > .smart-captcha {\n            width: 100%;\n            padding-bottom: 16px;\n          }\n        }\n      }\n    }\n  }\n}\n","@import \"font\";\n@import \"base\";\n@import \"buttons\";\n@import \"modal\";\n@import \"notify\";\n@import \"auth\";\n\n.app {\n  --map-height: 100vh;\n  --map-width: 100%;\n  --map-offset-x: 0;\n  --map-offset-y: 0;\n\n  @import \"map\";\n  @import \"menu\";\n  @import \"service/main\";\n  @import \"data\";\n}\n",".map-element {\n  height: var(--map-height);\n  width: var(--map-width);\n  cursor: default;\n\n  > .ol-viewport {\n    user-select: none;\n    -webkit-user-select: none;\n    -webkit-touch-callout: none;\n  }\n}\n\n.popup {\n  --height: 0px;\n  --width: 0px;\n  --icon-height: 0px;\n  --icon-width: 0px;\n  position: absolute;\n  background-color: white;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.2);\n  padding: 0;\n  border-radius: 10px;\n  border: 1px solid #cccccc;\n  bottom: calc(0px - var(--height) / 2); // -107px;\n  left: 27px;\n  max-width: 300px;\n\n  &:after, &:before {\n    bottom: calc(var(--height) / 2); // 107px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    transform: rotate(90deg);\n  }\n\n  &:after {\n    border-top-color: white;\n    border-width: 10px;\n    left: -10px;\n    margin-left: -9px;\n  }\n\n  &:before {\n    bottom: calc(var(--height) / 2 - 1px);\n    border-top-color: #cccccc;\n    border-width: 11px;\n    left: -11px;\n    margin-left: -11px;\n  }\n\n  &.position-left {\n    left: unset;\n    right: 27px;\n\n    &:before, &:after {\n      left: unset;\n      transform: rotate(-90deg);\n    }\n    &:before {\n      right: -23px;\n    }\n    &:after {\n      right: -20px;\n    }\n  }\n\n  &.position-down {\n    bottom: unset;\n    top: 15px;\n    left: calc(var(--width) / 2 * -1);\n\n    &:before, &:after {\n      top: -23px;\n      bottom: unset;\n      transform: rotate(180deg);\n    }\n    &:before {\n      left: calc(var(--width) / 2 + 1px);\n    }\n    &:after {\n      top: -20px;\n      left: calc(var(--width) / 2);\n    }\n  }\n\n  &.position-up {\n    bottom: calc(var(--icon-height) + 15px);\n    left: calc(var(--width) / 2 * -1);\n\n    &:before, &:after {\n      bottom: -20px;\n      transform: rotate(0deg);\n    }\n    &:before {\n      bottom: -23px;\n      left: calc(var(--width) / 2 + 1px);\n    }\n    &:after {\n      left: calc(var(--width) / 2);\n    }\n  }\n\n  > button {\n    text-decoration: none;\n    position: absolute;\n    top: 12px;\n    right: 16px;\n    border-radius: 12px;\n    width: 24px;\n    height: 24px;\n    background-color: #919EAB1F;\n    border: none;\n\n    svg {\n      font-size: 14px;\n      fill: #A1A9B5;\n    }\n  }\n\n  > div.popup-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 12px 16px;\n\n    .feature-popup-form {\n      @extend .small-text;\n      display: flex;\n      flex-direction: column;\n\n      .row {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        border-bottom: 1px solid #E9E9EB;\n        @extend .list-text;\n\n        &.header {\n          @extend .list-header-text;\n          border-bottom: none;\n          padding: 5px 0;\n        }\n\n        > div:first-child {\n          @extend .dark-text;\n          padding-right: 10px;\n          width: 100px;\n          flex-shrink: 0;\n\n          &:after {\n            content: \":\";\n          }\n        }\n\n        > div:nth-child(2) {\n          min-width: 150px;\n          flex-grow: 1;\n\n          &.obj_name {\n            font-weight: 600;\n            color: #124A74;\n          }\n        }\n      }\n    }\n  }\n}\n",".menu {\n  z-index: 10;\n  position: absolute;\n  min-width: 330px;\n  width: min(calc(100% - 44px), 350px);\n  height: 86px;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -120px;\n  background-color: $menu-background-color;\n  border-radius: 20px;\n  transition: 0.5s;\n\n  &.with-pagination {\n    height: 106px;\n  }\n\n  &.show {\n    bottom: 20px !important;\n  }\n\n  .pages {\n    display: flex;\n    overflow: auto;\n    overflow-x: scroll;\n    scroll-snap-type: x mandatory;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    >.items {\n      scroll-snap-align: start;\n      min-width: 100%;\n      height: 72px;\n      padding-top: 8px;\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n      white-space: nowrap;\n      overflow-x: auto;\n      gap: 44px;\n      justify-content: center;\n\n      > div {\n        height: 100%;\n        width: 40px;\n        min-width: 40px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        > div.item {\n          background-color: $color-fill;\n          border: 1px solid $border-color-white;\n          border-radius: 15px;\n          width: 40px;\n          min-width: 40px;\n          height: 40px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          overflow: hidden;\n\n           &.disabled {\n             background-color: #F0F2F566;\n             border-width: 0;\n           }\n\n          svg {\n            --fill: none;\n\n            &.friend-icon {\n              position: relative;\n              bottom: -9px;\n            }\n\n            &.adapter-icon {\n              position: relative;\n              bottom: -4px;\n              right: -4px;\n            }\n          }\n\n          >.anticon {\n            width: 100%;\n            height: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            >svg {\n              width: 80%;\n              height: 80%;\n            }\n          }\n        }\n\n        > div.selected {\n          position: absolute;\n          height: 5px;\n          width: 40px;\n          top: 0;\n          background-color: $menu-selected-color;\n          border-bottom-left-radius: 8px;\n          border-bottom-right-radius: 8px;\n        }\n\n        >span {\n          color: $text-color-white !important;\n          @extend .small-text;\n        }\n      }\n    }\n  }\n\n  >.pagination {\n    padding: 8px 0 12px 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 8px;\n\n    >.page-circle {\n      width: 6px;\n      height: 6px;\n      border-radius: 3px;\n      background-color: #C6CCD6;\n\n      &.selected {\n        background-color: #FFFFFF;\n      }\n    }\n  }\n}\n",".tongue {\n  z-index: 20;\n  position: absolute;\n  width: 100%;\n  max-height: 0;\n  bottom: 0 !important;\n  left: 0;\n  background-color: $dialog-background-color;\n  border-top-left-radius: 30px;\n  border-top-right-radius: 30px;\n  transition: max-height 0.8s;\n\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  &.full {\n    height: calc(100% - 12px);\n  }\n  &.half {\n    height: 100%;\n  }\n  &.fit-content {\n    max-height: 0;\n  }\n\n  &.show {\n    &.full {\n      max-height: calc(100% - 12px);\n    }\n    &.half {\n      max-height: calc(60% - 12px);\n    }\n    &.fit-content {\n      max-height: 500px;\n    }\n  }\n\n  > .swipe-toggle {\n    width: 100%;\n    height: 22px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    > div {\n      width: 30px;\n      min-width: 30px;\n      min-height: 4px;\n      background-color: $color-info-light;\n    }\n  }\n\n  > .tongue-wrapper {\n    flex-grow: 1;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    > .header {\n      @extend .primary-header-text;\n      text-align: left;\n      padding: 0 16px;\n\n      button.button-back {\n        border: 0;\n        box-shadow: unset;\n        width: unset;\n      }\n\n      >.actions {\n        float: right;\n        padding-left: 10px;\n\n        > button {\n          @extend .button-window-action;\n        }\n      }\n    }\n  }\n}\n\n.absolute-loader {\n  position: relative;\n\n  > .loader {\n    position: absolute;\n\n    > .back {\n      width: 100%;\n      height: 100%;\n      background-color: #FFFFFF;\n      z-index: 1;\n      opacity: 0.8;\n      position: absolute;\n    }\n\n    > div:nth-child(2) {\n      z-index: 2;\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n\n.empty-search-result {\n  display: flex;\n  flex-direction: column;\n}\n\n@import \"adapter\";\n@import \"track\";\n@import \"profile\";\n@import \"poi\";\n@import \"layer\";\n",".adapter {\n  .header {\n    .use-adapter-switch {\n      margin-left: 40px;\n    }\n  }\n\n  .body {\n    padding: 16px 12px;\n    text-align: right;\n    height: 100%;\n\n    > div:first-child {\n      padding-bottom: 10px;\n    }\n\n    >.ant-table-wrapper {\n      height: calc(100% - 50px);\n      overflow: auto;\n\n      .ant-table-row.overdue {\n        background-color: #DCDFE6;\n      }\n    }\n  }\n}\n",".track {\n  .list {\n\n    >.tongue-wrapper {\n      min-height: 300px;\n      @extend .absolute-loader;\n\n      > .header {\n        .add-button {\n          margin-left: 16px;\n          height: 32px;\n          background-color: $button-color-gray !important;\n          border: none;\n        }\n      }\n\n      > .ant-list {\n        height: 100%;\n        overflow: auto;\n        margin: 12px 0;\n        flex-grow: 1;\n\n        .ant-list-item {\n          padding: 16px;\n\n          &:hover {\n            cursor: pointer;\n            background-color: $background-lightgray;\n          }\n\n          .ant-list-item-meta-avatar {\n            margin-right: 8px;\n          }\n\n          .track-list-color {\n            display: block;\n            width: 2px;\n            height: 24px;\n\n            @each $name, $color in $color-list {\n              &.color-#{$name} {\n                background-color: map-get($color-list, $name);\n              }\n            }\n          }\n\n          .ant-list-item-action > li {\n            width: 32px;\n          }\n        }\n\n        .ant-list-empty-text {\n          padding-top: 32px;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n\n          > span {\n            padding-top: 12px;\n            @extend .primary-text\n          }\n        }\n      }\n\n      > .add-button {\n        margin: 12px 16px;\n      }\n\n      > .filter {\n        padding: 16px;\n        display: flex;\n        gap: 24px;\n\n        .ant-input-affix-wrapper {\n          border-radius: 6px;\n        }\n\n        .ant-input-group-addon {\n          display: none;\n        }\n\n        > button {\n          padding-inline: inherit;\n        }\n      }\n\n      > .hide-all-button-container {\n        padding: 12px 16px;\n\n        > button {\n          width: 100%;\n        }\n      }\n\n      > .no-tracks-text {\n        padding: 20px 16px;\n      }\n\n      > .search-error {\n        height: 100%;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        > .error-text {\n          flex-grow: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n        }\n\n        > .reload-button-container {\n          padding: 12px 16px;\n          display: flex;\n          justify-content: center;\n          width: 100%;\n\n          > button {\n            //width: 100%;\n            width: calc(100% - 32px);\n          }\n        }\n\n      }\n    }\n  }\n\n  .view {\n    .tongue-wrapper {\n      @extend .absolute-loader;\n\n      > .route {\n        display: flex;\n        padding: 24px 16px;\n\n        > .color-container {\n          width: 10px;\n\n          > .track-list-color {\n            display: block;\n            width: 2px;\n            height: 24px;\n\n            @each $name, $color in $color-list {\n              &.color-#{$name} {\n                background-color: map-get($color-list, $name);\n              }\n            }\n          }\n        }\n\n        > .route-data {\n          flex-grow: 1;\n\n          .list-header-text {\n            margin-bottom: 4px;\n          }\n        }\n      }\n\n      > .buttons {\n        padding: 0 16px 16px 16px;\n\n        > button {\n          margin: 14px;\n          border: 0;\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  .dialog {\n    width: calc(100% - 24px);\n    position: absolute;\n    bottom: 0;\n    margin: 12px;\n    background-color: $dialog-background-color;\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .start {\n    @extend .dialog;\n\n    button {\n      margin: 8px 8px 6px 8px;\n\n      &.cancel {\n        background-color: $dialog-background-color;\n        border: none;\n        margin: 6px 8px 8px 8px;\n      }\n    }\n  }\n\n  .record {\n    @extend .dialog;\n\n    .title {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 8px;\n\n      .animate {\n        background-color: #ffffff;\n        color: #ffffff;\n        animation: fadein 1s ease-in alternate infinite;\n      }\n\n      .primary-text {\n        padding: 4px 8px;\n      }\n    }\n\n    .buttons {\n      display: flex;\n      justify-content: center;\n      padding: 8px 12px;\n      gap: 5px;\n\n      > button {\n        flex-grow: 1;\n\n        &.complete {\n          background-color: $color-error;\n        }\n\n        &.minimize {\n          background-color: $dialog-background-color;\n          border: none;\n        }\n      }\n    }\n\n    &.minimized {\n      bottom: unset;\n      top: 12px;\n      right: 120px;\n      width: fit-content;\n      height: 64px;\n      margin: 0;\n      flex-direction: row;\n      justify-content: center;\n\n      > .title {\n        width: 140px;\n\n        > svg {\n          padding-right: 8px;\n        }\n      }\n    }\n  }\n\n  .save {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 20;\n    left: 0;\n    top: 0;\n    background-color: $dialog-background-color;\n\n    > .buttons {\n      height: 48px;\n\n      > button {\n        margin: 12px 16px;\n\n        &.button-back {\n          border: 0;\n          width: unset;\n        }\n\n        &.button-close {\n          float: right;\n          @extend .button-window-action;\n        }\n      }\n    }\n\n    .container {\n      height: calc(100% - 72px);\n      padding: 12px 16px;\n      display: flex;\n      flex-direction: column;\n\n      > span:nth-child(2) {\n        margin-top: 8px;\n        margin-bottom: 24px;\n      }\n\n      input {\n        margin-top: 8px;\n        margin-bottom: 24px;\n        padding: 14px 16px;\n      }\n\n      .colors {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 16px;\n\n        > div {\n          width: 40px;\n          height: 40px;\n          border-radius: 20px;\n          border: 1px solid $dialog-background-color;\n\n          &.selected {\n            border-color: $button-color-primary;\n          }\n\n          > div {\n            width: 32px;\n            height: 32px;\n            border-radius: 16px;\n            margin: 4px;\n\n            @each $name, $color in $color-list {\n              &.color-#{$name} {\n                background-color: map-get($color-list, $name);\n              }\n            }\n          }\n        }\n      }\n\n      > .buttons {\n        flex-grow: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n\n        > .empty-flex-grow-1 {\n          flex-grow: 1;\n        }\n\n        > button.button-delete {\n          margin-top: 26px;\n          color: $color-error;\n          padding: 0;\n          border: 0;\n        }\n\n        > button.button-save {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n",".profile {\n  .main {\n    > .tongue-wrapper {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      -webkit-overflow-scrolling: touch;\n      scroll-snap-type: y mandatory;\n      scroll-behavior: smooth;\n\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n\n      > .row-header {\n        padding: 24px 16px 8px 16px;\n        @extend .regular-header-text;\n        color: $text-color-regular;\n      }\n\n      > .row {\n        min-height: 80px;\n        margin: 0 16px;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n\n        &:hover {\n          cursor: pointer;\n          background-color: $background-lightgray;\n        }\n\n        .icon {\n          min-width: 40px;\n          min-height: 40px;\n          background-color: #F5F7FA;\n          border-radius: 8px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n\n        > .description {\n          flex-grow: 1;\n          padding: 0 16px;\n          display: flex;\n          flex-direction: column;\n\n          .title {\n            @extend .list-header-text;\n          }\n\n          * {\n            color: $text-color-regular !important;\n          }\n        }\n\n        > .action {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          min-width: 18px;\n        }\n\n        & + .row {\n          border-top: 1px solid $background-border-lightgray;\n        }\n\n        &.captain {\n          min-height: 88px;\n\n          > .description {\n            gap: 8px;\n          }\n        }\n\n        &.boat-add {\n          background-color: #EDF5FB;\n          border-radius: 16px;\n          padding: 16px;\n\n          > .icon {\n            background-color: $button-color-primary;\n          }\n        }\n\n        &.boat-info {\n          padding: 20px 0;\n\n          > .description {\n            padding: 0;\n            max-width: calc(100% - 18px);\n            gap: 8px;\n\n            > .header {\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n\n              > .title {\n                padding: 0 16px;\n              }\n            }\n\n            > .text {\n              @extend .regular-text;\n              text-overflow: ellipsis;\n              overflow: hidden;\n              white-space: nowrap;\n              max-width: 90%;\n\n              > .key {\n                color: $text-color-secondary !important;\n              }\n\n              > .value {\n                padding-left: 0.5em;\n                padding-right: 1em;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .profile-panel {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 20;\n    left: 0;\n    top: 0;\n    background-color: $dialog-background-color;\n\n    display: flex;\n    flex-direction: column;\n\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    scroll-snap-type: y mandatory;\n    scroll-behavior: smooth;\n\n    > .header {\n      padding: 12px 16px 0 16px;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      @extend .primary-header-text;\n      color: $text-color-primary;\n\n      > div {\n        flex-grow: 1;\n      }\n\n      > button {\n        @extend .button-window-action;\n      }\n    }\n\n    > .ant-form {\n      flex-grow: 1;\n      display: flex;\n      flex-direction: column;\n\n      .ant-form-item {\n        margin: 0;\n      }\n\n      > .ant-form-item {\n\n        > .ant-row {\n          display: flex;\n          flex-direction: column;\n          padding: 10px 16px;\n\n          > .ant-form-item-label {\n            padding-bottom: 8px;\n            text-align: unset;\n\n            > label {\n              @extend .primary-text;\n              height: 22px;\n              color: $text-color-regular;\n            }\n          }\n\n          .ant-input-affix-wrapper, .ant-input-number-input-wrap > input {\n            height: 48px;\n          }\n\n          .ant-select {\n            height: 48px;\n            width: 100%;\n          }\n\n          input, .ant-select-selection-item {\n            @extend .primary-text;\n            color: $text-color-regular;\n          }\n\n          input::placeholder, .ant-select-selection-placeholder {\n            @extend .primary-text;\n            color: $text-color-placeholder;\n          }\n        }\n      }\n\n      > .button-form-item {\n        flex-grow: 1;\n        align-content: flex-end;\n        margin-bottom: 14px;\n      }\n    }\n\n    > :not(.header) {\n      button {\n        width: 100%;\n        height: 48px;\n        margin-top: 12px;\n        @extend .secondary-header-text;\n\n        &.ant-btn-default {\n          border: none;\n          box-shadow: unset;\n          color: $button-color-primary;\n        }\n\n        &.ant-btn-primary {\n          background-color: $button-color-primary;\n\n          > span {\n            @extend .secondary-header-text;\n            color: $button-text-color-primary !important;\n          }\n        }\n\n        &:disabled {\n          background-color: $background-border-lightgray;\n\n          > span {\n            color: $text-color-placeholder !important;\n          }\n        }\n      }\n    }\n\n    &.boat-info-form {\n\n      > .steps {\n        padding: 32px 16px;\n\n        &.empty {\n          padding: 25px 16px;\n        }\n\n        .ant-steps-item-icon {\n          line-height: 24px;\n          height: 24px;\n          @extend .secondary-header-text;\n        }\n\n        .ant-steps-item-active {\n          .ant-steps-item-icon {\n            color: $button-text-color-primary;\n            background-color: $button-color-primary;\n            border-color: $button-color-primary;\n          }\n        }\n\n        .ant-steps-item-wait {\n          .ant-steps-item-icon {\n            color: $text-color-gray;\n            background-color: $background-lightgray;\n            border-color: $background-border-lightgray;\n          }\n        }\n\n        .ant-steps-item-finish {\n          .ant-steps-item-icon {\n            background-color: $background-lightblue;\n            border-color: $background-border-lightblue;\n\n            svg {\n              color: $button-color-primary;\n            }\n          }\n\n          .ant-steps-item-title::after {\n            background-color: $button-color-primary;\n          }\n        }\n\n        .ant-steps-item-title::after {\n          top: 12px;\n        }\n      }\n\n      > .ant-form {\n\n        > .header {\n          padding: 0 16px 14px 16px;\n\n          > .title {\n            @extend .list-header-text;\n          }\n\n          > .text {\n            padding-top: 4px;\n            @extend .primary-text;\n            color: $text-color-secondary;\n          }\n        }\n\n        > .ant-form-item {\n\n          > .ant-row {\n\n            .tracking-radio {\n              .ant-form-item-control-input {\n                height: 48px;\n              }\n            }\n\n            .ant-form-item-control-input-content {\n              > div {\n                > .dimension-row {\n                  display: flex;\n                  flex-direction: row;\n\n                  > div:first-child {\n                    flex-grow: 1;\n\n                    .ant-input-number {\n                      width: 100%;\n                    }\n                  }\n\n                  .switch {\n                    display: flex;\n                    flex-direction: row;\n                    padding-left: 12px;\n\n                    > div {\n                      width: 73px;\n                      height: 48px;\n                      line-height: 48px;\n                      text-align: center;\n                      @extend .secondary-header-text;\n                      border: 1px solid $border-color;\n                      color: $text-color-gray-2;\n\n                      &.left {\n                        border-bottom-left-radius: 6px;\n                        border-top-left-radius: 6px;\n                      }\n\n                      &.right {\n                        border-bottom-right-radius: 6px;\n                        border-top-right-radius: 6px;\n                      }\n\n                      &.selected {\n                        background-color: $button-color-primary;\n                        color: $button-text-color-primary;\n                        border-color: $button-color-primary;\n                      }\n                    }\n                  }\n                }\n\n                > .hint {\n                  width: fit-content;\n                  margin-top: 8px;\n                  @extend .small-text;\n                  color: $button-color-primary;\n                  cursor: pointer;\n                }\n              }\n            }\n\n            .ant-input-number {\n              display: block;\n              width: 100%;\n            }\n          }\n        }\n\n        .buttons {\n          padding: 22px 16px 10px 16px;\n          display: flex;\n          flex-direction: row;\n\n          > * {\n            width: 100%;\n          }\n        }\n\n      }\n    }\n\n    &.captain-form {\n\n      > .ant-form {\n        margin-top: 14px;\n      }\n    }\n  }\n}\n",".poi {\n\n  .main {\n\n    &.tongue.show {\n      min-width: 380px;\n    }\n\n    >.tongue-wrapper {\n\n      > .header {\n        display: flex;\n        flex-wrap: nowrap;\n        text-wrap: nowrap;\n\n        .add-button {\n          flex-grow: 1;\n\n          > button {\n            margin-left: 16px;\n            height: 32px;\n            background-color: $button-color-gray !important;\n            border: none;\n          }\n        }\n      }\n\n      > .ant-collapse {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        --height: 500px;\n\n        .ant-collapse-item {\n          padding: 0 15px;\n\n          &.ant-collapse-item-disabled > .ant-collapse-header {\n            cursor: default;\n          }\n\n          &.ant-collapse-item-active {\n            flex-grow: 1;\n          }\n\n          .ant-collapse-content-box {\n            padding: 0;\n          }\n\n          .ant-collapse-header {\n            padding: 0;\n          }\n\n          .list, .categories {\n            height: var(--height);\n          }\n\n          &:first-child {\n\n            .ant-collapse-header {\n              .filter {\n                padding: 16px 5px 5px 5px;\n                display: flex;\n                flex-direction: column;\n                gap: 20px;\n\n                > .row {\n                  display: flex;\n                  flex-direction: row;\n\n                  &:first-child {\n                    gap: 22px;\n\n                    .ant-input-affix-wrapper {\n                      border-radius: 6px;\n                    }\n\n                    .ant-input-group-addon {\n                      display: none;\n                    }\n\n                    > button {\n                      padding-inline: inherit;\n                    }\n                  }\n\n                  > .ant-slider {\n                    width: 100%;\n                  }\n\n                  > .radius {\n                    width: 105px;\n                    max-width: 85px;\n                    text-align: right;\n                    overflow: hidden;\n\n                    @extend .secondary-header-text;\n\n                    height: 34px;\n                    line-height: 34px;\n                  }\n                }\n              }\n            }\n\n            .list {\n\n              @extend .absolute-loader;\n\n              > .search-error {\n                height: 100%;\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n\n                > .error-text {\n                  flex-grow: 1;\n                  display: flex;\n                  flex-direction: column;\n                  align-items: center;\n                  justify-content: center;\n                }\n\n                > .reload-button-container {\n                  padding: 12px 16px;\n                  display: flex;\n                  justify-content: center;\n                  width: 100%;\n\n                  > button {\n                    //width: 100%;\n                    width: calc(100% - 32px);\n                  }\n                }\n\n              }\n\n              > .ant-list {\n                height: 100%;\n                overflow: auto;\n                flex-grow: 1;\n\n                .ant-list-item {\n                  padding: 16px;\n\n                  &:hover {\n                    background-color: $background-lightgray;\n                    cursor: pointer;\n                  }\n\n                  .ant-list-item-meta-avatar {\n                    margin-right: 20px;\n\n                    .points-list-color {\n                      display: block;\n\n                      @each $name, $color in $color-list {\n                        &.color-#{$name} {\n                          background-color: map-get($color-list, $name);\n                        }\n                      }\n                    }\n                  }\n                }\n\n                .ant-list-empty-text {\n                  padding-top: 32px;\n                  display: flex;\n                  flex-direction: column;\n                  justify-content: center;\n                  align-items: center;\n\n                  > span {\n                    padding-top: 12px;\n                    @extend .primary-text\n                  }\n                }\n\n                .ant-list-item-action > li {\n                  width: 32px;\n                }\n              }\n            }\n          }\n\n          &:nth-child(2) {\n            border-top: 1px solid $border-color;\n\n            &:not(.ant-collapse-item-active) > .ant-collapse-header:hover {\n              cursor: pointer;\n              background-color: $background-lightgray;\n            }\n\n            .ant-collapse-header {\n              //text-align: center;\n              padding: 12px 0;\n              @extend .secondary-header-text;\n\n              .category {\n\n                > span {\n                  margin-left: 5px;\n                  @extend .secondary-header-text;\n                }\n\n                > .title {\n                  color: $text-color-secondary;\n                  &:after {\n                    content: \":\";\n                  }\n                }\n\n                .selected {\n                  .clear-icon {\n                    float: right;\n                    margin-right: 5px;\n\n                    > svg {\n                      width: 18px;\n                      height: 18px;\n                    }\n                  }\n                }\n              }\n            }\n\n            .categories {\n\n              > .category {\n                width: calc(50% - 32px);\n                padding: 16px;\n                display: flex;\n                flex-direction: row;\n                flex-wrap: nowrap;\n                border-radius: 8px;\n\n                &:nth-child(2n) {\n                  float: right;\n                }\n                &:nth-child(2n+1) {\n                  float: left;\n                }\n\n                &:hover {\n                  background-color: $background-lightgray;\n                  cursor: pointer;\n                }\n\n                &.selected {\n                  background-color: $background-lightblue;\n                }\n\n                > .icon {\n                  background-color: #124A74;\n                  margin-right: 8px;\n                  width: 60px;\n                  height: 60px;\n                  flex-grow: 0;\n                  flex-shrink: 0;\n\n                  &.user {\n                    background-color: #D6B36A;\n                  }\n                }\n\n                > .title {\n                  @extend .primary-text;\n                  flex-grow: 1;\n                  display: flex;\n                  align-items: center;\n                  justify-content: flex-start;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .dialog {\n    width: calc(100% - 24px);\n    position: absolute;\n    bottom: 0;\n    margin: 12px;\n    background-color: $dialog-background-color;\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .new {\n    @extend .dialog;\n\n    button {\n      margin: 8px 8px 6px 8px;\n\n      &.cancel {\n        background-color: $dialog-background-color;\n        border: none;\n        margin: 6px 8px 8px 8px;\n      }\n    }\n  }\n\n  .save {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 20;\n    left: 0;\n    top: 0;\n    background-color: $dialog-background-color;\n\n    > .buttons {\n      height: 48px;\n\n      > button {\n        margin: 12px 16px;\n\n        &.button-back {\n          border: 0;\n          width: unset;\n        }\n\n        &.button-close {\n          float: right;\n          @extend .button-window-action;\n        }\n      }\n    }\n\n    .container {\n      height: calc(100% - 72px);\n      padding: 12px 16px;\n      display: flex;\n      flex-direction: column;\n\n      > span:nth-child(2) {\n        margin-top: 8px;\n        margin-bottom: 24px;\n      }\n\n      input, textarea {\n        margin-top: 8px;\n        margin-bottom: 24px;\n        padding: 14px 16px;\n      }\n\n      .colors {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 16px;\n\n        > div {\n          padding: 4px;\n          border-radius: 50%;\n          border: 1px solid $dialog-background-color;\n\n          &.selected {\n            border-color: $button-color-primary;\n          }\n\n          > span {\n            @each $name, $color in $color-list {\n              &.color-#{$name} {\n                background-color: map-get($color-list, $name);\n              }\n            }\n          }\n        }\n      }\n\n      > .buttons {\n        flex-grow: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n\n        > .empty-flex-grow-1 {\n          flex-grow: 1;\n        }\n\n        > button.button-delete {\n          margin-top: 26px;\n          color: $color-error;\n          padding: 0;\n          border: 0;\n        }\n\n        > button.button-save {\n          width: 100%;\n        }\n      }\n    }\n}\n\n  .view {\n    .tongue-wrapper {\n      @extend .absolute-loader;\n\n      > .point {\n        display: flex;\n        padding: 24px 16px 5px 16px;\n        flex-grow: 1;\n\n        > .point-data {\n          flex-grow: 1;\n\n          .title {\n            @extend .list-header-text;\n            margin-bottom: 20px;\n            display: flex;\n            flex-direction: row;\n\n            .point-icon {\n              min-width: 32px;\n              margin-right: 20px;\n\n              @each $name, $color in $color-list {\n                &.color-#{$name} {\n                  background-color: map-get($color-list, $name);\n                }\n              }\n            }\n          }\n\n          .text {\n            @extend .list-text;\n            max-height: 280px;\n            overflow-y: auto;\n\n            >.block {\n              padding: 10px;\n\n              &:not(.contact) {\n                > .row {\n                   &.value {\n                     > p, a {\n                      border-bottom: 1px solid $border-color;\n                     }\n                   }\n                }\n              }\n\n              &.contact {\n                background-color: $background-blue;\n                border-radius: 8px;\n              }\n\n              > .row {\n                padding: 3px 0;\n\n                &.code {\n                  padding-bottom: 7px;\n                  color: $text-color-primary;\n\n                  &:after {\n                    content: \":\";\n                  }\n                }\n\n                &.value {\n\n                  > a {\n                    color: $text-link-color;\n                    text-decoration: none;\n                  }\n\n                  > p, a {\n                    display: block;\n                    margin: 0;\n                    padding: 3px 0;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      > .buttons {\n        padding: 0 16px 16px 16px;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n\n\n        > button {\n          margin: 14px;\n          border: 0;\n          padding: 0;\n\n          &.button-error, &.button-publish {\n            @extend .regular-text;\n            color: $text-color-primary;\n\n            svg {\n              width: 18px;\n              height: 18px;\n            }\n          }\n          &.button-error {\n            color: $color-error;\n          }\n        }\n      }\n    }\n  }\n}\n\n.new-point {\n  position: absolute;\n  right: calc(var(--map-width) / 2);\n  top: calc(var(--map-height) / 2);\n  transform: translate(50%) translateY(-100%);\n  background-size: cover;\n  z-index: 1000;\n  width: 50px;\n  height: 50px;\n  background-image: url(\"/public/new-point.png\");\n}\n",".layer {\n  .main {\n\n    &.tongue.show {\n      min-width: 350px;\n    }\n\n    > .tongue-wrapper {\n\n      > .ant-list {\n        margin-top: 20px;\n        height: 100%;\n        overflow: auto;\n\n        .ant-list-item {\n          cursor: pointer;\n          padding: 16px;\n\n          .ant-list-item-meta-avatar {\n            margin-right: 20px;\n\n            > .icon {\n              background-color: #124A74;\n              margin-right: 20px;\n\n              &.user {\n                background-color: #D6B36A;\n              }\n            }\n          }\n        }\n\n        .ant-list-item-action > li {\n          width: 32px;\n        }\n      }\n    }\n  }\n}\n",".data {\n  z-index: 10;\n  position: absolute;\n  width: 110px;\n  margin-right: 12px;\n  right: 0;\n  top: 12px;\n\n  > div {\n    background-color: $dialog-background-color;\n    height: 64px;\n    border-radius: 20px;\n    text-align: center;\n    padding: 0 16px;\n\n    > div:first-child {\n      padding-top: 8px;\n    }\n\n    .speed-value {\n      text-align: left;\n      padding-right: 5px;\n    }\n  }\n}\n\n.adapter-data {\n  .widget {\n    position: absolute;\n    background-color: white;\n    z-index: 10;\n    top: 100px;\n\n    padding: 10px;\n    border-radius: 20px;\n    text-align: center;\n\n    .value {\n      text-align: left;\n      padding-right: 5px;\n    }\n  }\n}\n",".auth > .form {\n  width: 100%;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding-top: 0;\n\n  > div {\n    min-width: 70%;\n\n    &.logo {\n      min-width: 180px;\n      flex-basis: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      > svg {\n        width: 130px;\n        height: 130px;\n      }\n    }\n\n    &.login {\n      padding-top: 5px;\n      overflow: auto;\n      max-width: min(70%, 600px);\n      flex-basis: calc(100% - 70px);\n\n      .welcome-text {\n        padding-top: 0;\n      }\n\n      >.data {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n        >.loader {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n\n          > div:nth-child(2) {\n            width: 200px;\n            height: 100px;\n          }\n        }\n      }\n    }\n\n    &.footer {\n      padding: 15px 0;\n    }\n\n  }\n}\n\n.track {\n  display: none !important;\n}\n\n.menu {\n  display: none !important;\n}\n\n.profile {\n  display: none !important;\n}\n","&.modal {\n  width: 432px;\n  margin: unset;\n\n  .ant-modal-content {\n    padding: 40px;\n\n    .ant-modal-title {\n      @extend .primary-header-text;\n    }\n\n    .ant-modal-body {\n      @extend .regular-text;\n    }\n\n    .ant-modal-footer >.buttons {\n      flex-direction: row-reverse;\n      gap: 28px;\n    }\n  }\n\n  &.confirm-dialog {\n    .ant-modal-content > .ant-modal-header > .ant-modal-title {\n      padding: 0 10px;\n      text-align: center;\n    }\n  }\n}\n\n.auth > .form {\n  flex-wrap: nowrap;\n  justify-content: center;\n  width: 548px;\n\n  > div {\n    &.logo {\n      >svg {\n        width: 106px;\n        height: 106px;\n      }\n    }\n\n    &.login {\n      flex-grow: 0;\n\n      .data {\n        flex-grow: 0;\n        margin-bottom: 34px;\n\n        >.loader {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n\n          > div:nth-child(2) {\n            width: 300px;\n            height: 170px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.menu {\n  width: 650px;\n  height: 96px;\n\n  &.with-pagination {\n    height: 126px;\n  }\n\n  >.pages >.items {\n    gap: 65px;\n    height: 68px;\n    padding: 16px 0 12px 0;\n\n    >div >.item {\n      width: 48px !important;\n      height: 48px !important;\n    }\n  }\n}\n\n.tongue {\n  flex-direction: row-reverse;\n  max-width: 0;\n  min-width: 0;\n  max-height: unset;\n  border-radius: 12px;\n  bottom: unset;\n  top: 0;\n  transition: max-width 0.5s, min-width 0.5s;\n\n  margin: 12px 0 20px 12px;\n\n  &.full {\n    height: calc(100% - 32px);\n  }\n  &.fit-content {\n    max-height: fit-content;\n  }\n\n  &.show {\n    max-width: 30% !important;\n    min-width: 330px;\n\n    &.full {\n      max-height: calc(100% - 32px);\n    }\n    &.fit-content {\n      max-height: fit-content;\n    }\n  }\n\n  > .swipe-toggle {\n    height: auto;\n    width: 0;\n    display: flex;\n    justify-content: left;\n    align-items: center;\n\n    > div {\n      position: relative;\n      left: -12px;\n      height: 30px;\n      width: unset;\n      min-height: 30px;\n      min-width: 4px;\n    }\n  }\n\n  > .tongue-wrapper {\n    min-width: 320px;\n\n    >.header {\n      margin-top: 16px;\n    }\n  }\n}\n\n.track {\n\n  .start {\n    width: 350px;\n    left: calc(50% - 187px);\n  }\n\n  .save {\n    width: 520px;\n    height: 428px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 16px;\n\n    >.buttons {\n      height: 40px;\n    }\n\n    .container {\n      padding: 0 40px 40px 40px;\n      width: calc(100% - 80px);\n      height: calc(100% - 88px);\n\n      >div:first-child {\n        margin-bottom: unset;\n      }\n\n      >.buttons {\n        flex-direction: row;\n        align-items: flex-end;\n\n        >button.button-delete {\n          margin-top: unset;\n        }\n        >button.button-save {\n          width: unset;\n        }\n      }\n    }\n  }\n}\n\n.poi {\n  .new {\n    width: 350px;\n    left: calc(50% - 187px);\n  }\n\n  .save {\n    width: 520px;\n    height: 560px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 16px;\n\n    >.buttons {\n      height: 40px;\n    }\n\n    .container {\n      padding: 0 40px 40px 40px;\n      width: calc(100% - 80px);\n      height: calc(100% - 88px);\n\n      >div:first-child {\n        margin-bottom: unset;\n      }\n\n      >.buttons {\n        flex-direction: row;\n        align-items: flex-end;\n\n        >button.button-delete {\n          margin-top: unset;\n        }\n        >button.button-save {\n          width: unset;\n        }\n      }\n    }\n  }\n\n  .view {\n    .tongue-wrapper {\n      .point > .point-data {\n        .text {\n          max-height: 700px;\n        }\n      }\n    }\n  }\n}\n\n.adapter {\n  &.tongue.show {\n      min-width: 400px !important;\n  }\n}\n\n.profile {\n  > .tongue {\n\n    &.show {\n      min-width: 370px !important;\n    }\n\n    &.main {\n      > .tongue-wrapper {\n        > .header {\n          justify-content: flex-end;\n        }\n\n        > .row {\n          min-height: 78px;\n\n          &.boat-info {\n            padding: 16px 0;\n          }\n        }\n      }\n    }\n\n    > .tongue-wrapper {\n\n      >.header {\n        display: flex;\n        flex-direction: row;\n\n        > .title {\n          flex-grow: 1;\n          text-align: right;\n        }\n      }\n    }\n\n    .profile-panel {\n      position: unset;\n      z-index: unset;\n      top: unset;\n      left: unset;\n\n      > .ant-form {\n        .ant-row > .ant-col {\n          min-height: unset;\n        }\n      }\n    }\n  }\n}\n",".auth > .form {\n  > div {\n    flex-basis: unset;\n    max-width: unset;\n    overflow: auto;\n  }\n}\n\n.menu {\n  display: block !important;\n}\n\n.track {\n  display: unset !important;\n}\n\n.profile {\n  display: unset !important;\n}\n\n.poi {\n  .view {\n    .tongue-wrapper {\n      .point > .point-data {\n        .text {\n          max-height: 500px;\n        }\n      }\n    }\n  }\n}\n\n","@import \"../tablet/portrait\";\n\n.auth {\n  flex-direction: row;\n  padding: 24px !important;\n  width: calc(100% - 48px);\n  height: calc(100% - 48px);\n\n  > div {\n    flex: 1;\n  }\n\n  > .form {\n    width: unset;\n    align-items: center;\n\n    > div {\n      max-width: 448px !important;\n    }\n  }\n\n  > .auth-img {\n    display: none;\n  }\n}\n\n.app {\n  --map-width: calc(100% - 60px);\n\n  .map-element {\n    float: right;\n  }\n\n  .left-menu {\n    width: 60px;\n    height: 100vh;\n    padding-top: 20px;\n    border-right: 1px solid var(--Color-Border-border-color-light, #E4E7ED);\n\n    > .item {\n      height: 50px;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      @mixin left-icon-color($color) {\n        > path {\n          &[stroke]:not([stroke=\"\"]) {\n            stroke: $color;\n          }\n\n          &[fill]:not([fill=\"\"]) {\n            fill: $color;\n          }\n        }\n      }\n\n      &:not(.disabled) > svg:hover, &.selected > svg {\n        @include left-icon-color(#0088FF);\n      }\n\n      &.disabled > svg {\n        @include left-icon-color(#A1A9B5);\n      }\n\n      &:not(.disabled):not(.selected):hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .tongue {\n    left: 60px;\n    margin: 0;\n    border-radius: 0;\n    height: 100vh;\n    max-height: unset !important;\n    box-shadow: 2px 4px 8px 0 #00000014;\n\n    &.show {\n      max-width: 25% !important;\n      min-width: 400px !important;\n    }\n\n    > .swipe-toggle {\n      display: none;\n    }\n  }\n\n  .track {\n    .start {\n      left: calc(50% - 187px + 30px);\n    }\n  }\n\n  .poi {\n    > .tongue.show {\n      min-width: 410px !important;\n    }\n\n    .new {\n      left: calc(50% - 187px + 30px);\n    }\n  }\n}\n\n.poi {\n\n  .main {\n    .tongue-wrapper {\n      .categories > .category > .icon {\n        width: 70px !important;\n        height: 70px !important;\n      }\n    }\n  }\n\n  .view {\n    .tongue-wrapper {\n      .point > .point-data {\n        .text {\n          max-height: unset !important;\n        }\n      }\n    }\n  }\n}\n","@import \"../tablet/landscape\";\n\n.auth {\n  > .auth-img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-image: url(\"/public/auth-background.png\");\n    border-radius: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
